export const FAKE_PERSONNEL_LIST = [
  {
    "name": "王小明",
    "categoryTitle": "人事身份",
    "companyName": "任職公司",
    "title": "專業講師",
    "avatar": 'https://assets.codepen.io/1759070/pet-3%402x.png',
    "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字"
  }
];

export const FAKE_EVENT_LIST = [
  {
    "title": "Microsoft 365 技術體驗營(單天統一報名)",
    "alias": "microsoft365",
    "categoryTitle": "課程",
    "type": "physical",
    "dateType": "single",
    "registrationType": "impartial",
    "registrationStartDate": "2021-10-07 12:39:00",
    "registrationEndDate": "2021-11-08 23:59:59",
    "inProgress": 0,
    "canApply": 0,
    "seriesNum": "3YGFV",
    "canRegisterGroup": 1,
    "brands": [
      {
        "title": "Aimetis",
        "alias": "aimetis",
        "logo": "https://assets.codepen.io/1759070/logo_1.svg"
      }
    ],
    "dateTimeRange": "2020/01/01(五) (13:00至16:40)"
  },
  {
    "title": "IxDTW 互動設計年會 2021（多天統一報名）",
    "alias": "ixda2021",
    "categoryTitle": "課程",
    "type": "physical",
    "dateType": "multiple",
    "registrationType": "partial",
    "registrationStartDate": "2021-08-26 07:59:59",
    "registrationEndDate": "2021-10-02 23:59:59",
    "inProgress": 0,
    "canApply": 1,
    "seriesNum": "NSTLB",
    "canRegisterGroup": 6,
    "brands": [
      {
        "title": "BlcakBerry",
        "alias": "blcakberry",
        "logo": "https://assets.codepen.io/1759070/logo_1.svg"
      },
      {
        "title": "VMware",
        "alias": "vmware",
        "logo": "https://assets.codepen.io/1759070/logo_1.svg"
      }
    ],
    "dateTimeRange": "2020/01/01(五) ~ 2020/01/02(六)"
  },
  {
    "title": "Modernweb 2021(單天依場次報名)",
    "alias": "modernweb2021",
    "categoryTitle": "課程",
    "type": "online",
    "dateType": "single",
    "registrationType": "partial",
    "registrationStartDate": "2021-08-26 07:59:59",
    "registrationEndDate": "2022-10-02 23:59:59",
    "inProgress": 0,
    "canApply": 1,
    "seriesNum": "DCYMK",
    "canRegisterGroup": 7,
    "brands": [
      {
        "title": "Aimetis",
        "alias": "aimetis",
        "logo": "https://assets.codepen.io/1759070/logo_1.svg"
      },
      {
        "title": "F5",
        "alias": "f5",
        "logo": "https://assets.codepen.io/1759070/logo_1.svg"
      }
    ],
    "dateTimeRange": "2020/01/01(五) (13:00至16:40)"
  },
  {
    "title": "Microsoft 365 技術體驗營(單天統一報名)",
    "alias": "microsoft365",
    "categoryTitle": "課程",
    "type": "physical",
    "dateType": "single",
    "registrationType": "impartial",
    "registrationStartDate": "2021-10-07 12:39:00",
    "registrationEndDate": "2021-11-08 23:59:59",
    "inProgress": 0,
    "canApply": 0,
    "seriesNum": "3YGFV",
    "canRegisterGroup": 1,
    "brands": [
      {
        "title": "Aimetis",
        "alias": "aimetis",
        "logo": "https://assets.codepen.io/1759070/logo_1.svg"
      },
      {
        "title": "F5",
        "alias": "f5",
        "logo": "https://assets.codepen.io/1759070/logo_1.svg"
      }
    ],
    "dateTimeRange": "2020/01/01(五) (13:00至16:40)"
  },
  {
    "title": "IxDTW 互動設計年會 2021（多天統一報名）",
    "alias": "ixda2021",
    "categoryTitle": "課程",
    "type": "physical",
    "dateType": "multiple",
    "registrationType": "partial",
    "registrationStartDate": "2021-08-26 07:59:59",
    "registrationEndDate": "2021-10-02 23:59:59",
    "inProgress": 0,
    "canApply": 1,
    "seriesNum": "NSTLB",
    "canRegisterGroup": 6,
    "brands": [
      {
        "title": "BlcakBerry",
        "alias": "blcakberry",
        "logo": "https://assets.codepen.io/1759070/logo_1.svg"
      },
      {
        "title": "VMware",
        "alias": "vmware",
        "logo": "https://assets.codepen.io/1759070/logo_1.svg"
      }
    ],
    "dateTimeRange": "2020/01/01(五) ~ 2020/01/02(六)"
  },
  {
    "title": "Modernweb 2021(單天依場次報名)",
    "alias": "modernweb2021",
    "categoryTitle": "課程",
    "type": "online",
    "dateType": "single",
    "registrationType": "partial",
    "registrationStartDate": "2021-08-26 07:59:59",
    "registrationEndDate": "2022-10-02 23:59:59",
    "inProgress": 0,
    "canApply": 1,
    "seriesNum": "DCYMK",
    "canRegisterGroup": 7,
    "brands": [
      {
        "title": "Aimetis",
        "alias": "aimetis",
        "logo": "https://assets.codepen.io/1759070/logo_1.svg"
      },
      {
        "title": "F5",
        "alias": "f5",
        "logo": "https://assets.codepen.io/1759070/logo_1.svg"
      }
    ],
    "dateTimeRange": "2020/01/01(五) (13:00至16:40)"
  },
  {
    "title": "Microsoft 365 技術體驗營(單天統一報名)",
    "alias": "microsoft365",
    "categoryTitle": "課程",
    "type": "physical",
    "dateType": "single",
    "registrationType": "impartial",
    "registrationStartDate": "2021-10-07 12:39:00",
    "registrationEndDate": "2021-11-08 23:59:59",
    "inProgress": 0,
    "canApply": 0,
    "seriesNum": "3YGFV",
    "canRegisterGroup": 1,
    "brands": [
      {
        "title": "Aimetis",
        "alias": "aimetis",
        "logo": "https://assets.codepen.io/1759070/logo_1.svg"
      },
      {
        "title": "F5",
        "alias": "f5",
        "logo": "https://assets.codepen.io/1759070/logo_1.svg"
      }
    ],
    "dateTimeRange": "2020/01/01(五) (13:00至16:40)"
  },
  {
    "title": "IxDTW 互動設計年會 2021（多天統一報名）",
    "alias": "ixda2021",
    "categoryTitle": "課程",
    "type": "physical",
    "dateType": "multiple",
    "registrationType": "partial",
    "registrationStartDate": "2021-08-26 07:59:59",
    "registrationEndDate": "2021-10-02 23:59:59",
    "inProgress": 0,
    "canApply": 1,
    "seriesNum": "NSTLB",
    "canRegisterGroup": 6,
    "brands": [
      {
        "title": "BlcakBerry",
        "alias": "blcakberry",
        "logo": "https://assets.codepen.io/1759070/logo_1.svg"
      },
      {
        "title": "VMware",
        "alias": "vmware",
        "logo": "https://assets.codepen.io/1759070/logo_1.svg"
      }
    ],
    "dateTimeRange": "2020/01/01(五) ~ 2020/01/02(六)"
  },
  {
    "title": "Modernweb 2021(單天依場次報名)",
    "alias": "modernweb2021",
    "categoryTitle": "課程",
    "type": "online",
    "dateType": "single",
    "registrationType": "partial",
    "registrationStartDate": "2021-08-26 07:59:59",
    "registrationEndDate": "2022-11-02 23:59:59",
    "inProgress": 1,
    "canApply": 1,
    "seriesNum": "DCYMK",
    "canRegisterGroup": 7,
    "brands": [
      {
        "title": "Aimetis",
        "alias": "aimetis",
        "logo": "https://assets.codepen.io/1759070/logo_1.svg"
      },
      {
        "title": "F5",
        "alias": "f5",
        "logo": "https://assets.codepen.io/1759070/logo_1.svg"
      }
    ],
    "dateTimeRange": "2020/01/01(五) (13:00至16:40)"
  }
];

export const FAKE_EVENT_LIST_2 = [
  {
    "title": "adasd",
    "alias": "v1fapmkfxkhqcrlg",
    "categoryTitle": "活動",
    "type": "online",
    "dateType": "single",
    "registrationType": "impartial",
    "registrationStartDate": "2021-10-01 00:00:00",
    "registrationEndDate": "2021-12-04 00:00:00",
    "canRegisterGroup": 7,
    "inProgress": 0,
    "canApply": 1,
    "seriesNum": "4QINK",
    "brands": [
      {
        "title": "VMware",
        "alias": "vmware",
        "logo": null,
        "contact": []
      }
    ],
    "dateTimeRange": "2021/10/30(六) (08:00-11:00)"
  },
  {
    "title": "Microsoft 365 技術體驗營(單天統一報名)",
    "alias": "microsoft365",
    "categoryTitle": "課程",
    "type": "physical",
    "dateType": "single",
    "registrationType": "impartial",
    "registrationStartDate": "2021-10-01 07:59:59",
    "registrationEndDate": "2021-10-31 23:59:59",
    "canRegisterGroup": 7,
    "inProgress": 0,
    "canApply": 1,
    "seriesNum": "A1ZGP",
    "brands": [
      {
        "title": "Aimetis",
        "alias": "aimetis",
        "logo": null,
        "contact": []
      },
      {
        "title": "F5",
        "alias": "f5",
        "logo": null,
        "contact": []
      }
    ],
    "dateTimeRange": "2021/11/01(ㄧ) (00:00-16:00)"
  },
  {
    "title": "Modernweb 2021(單天依場次報名)",
    "alias": "modernweb2021",
    "categoryTitle": "課程",
    "type": "online",
    "dateType": "single",
    "registrationType": "partial",
    "registrationStartDate": "2021-07-26 07:59:00",
    "registrationEndDate": "2021-10-30 23:59:00",
    "canRegisterGroup": 7,
    "inProgress": 0,
    "canApply": 1,
    "seriesNum": "UVY4O",
    "brands": [
      {
        "title": "Aimetis",
        "alias": "aimetis",
        "logo": null,
        "contact": []
      },
      {
        "title": "F5",
        "alias": "f5",
        "logo": null,
        "contact": []
      }
    ],
    "dateTimeRange": "2021/11/01(ㄧ) (14:00-14:40)"
  },
  {
    "title": "IxDTW 互動設計年會 2021（多天依照場次報名）",
    "alias": "ixda2021",
    "categoryTitle": "課程",
    "type": "physical",
    "dateType": "multiple",
    "registrationType": "partial",
    "registrationStartDate": "2021-08-26 07:59:59",
    "registrationEndDate": "2021-12-02 23:59:59",
    "canRegisterGroup": 7,
    "inProgress": 0,
    "canApply": 1,
    "seriesNum": "YJTO5",
    "brands": [
      {
        "title": "VMware",
        "alias": "vmware",
        "logo": null,
        "contact": []
      }
    ],
    "dateTimeRange": "2021/12/03(五) ~ 2021/12/04(六)"
  },
  {
    "title": "PyConTW 2021(多天統一報名)",
    "alias": "pycontw2021",
    "categoryTitle": "課程",
    "type": "phisical",
    "dateType": "multiple",
    "registrationType": "impartial",
    "registrationStartDate": "2021-07-26 07:59:59",
    "registrationEndDate": "2021-12-15 23:59:59",
    "canRegisterGroup": 1,
    "inProgress": 0,
    "canApply": 1,
    "seriesNum": "PHW4M",
    "brands": [
      {
        "title": "Aimetis",
        "alias": "aimetis",
        "logo": null,
        "contact": []
      },
      {
        "title": "F5",
        "alias": "f5",
        "logo": null,
        "contact": []
      }
    ],
    "dateTimeRange": "2021/12/15(三) ~ 2021/12/16(四)"
  }
];

// 實體 單天 統一報名
export const FAKE_EVENT_ITEM_PHYSICAL_SINGLE_IMPARTIAL = {
  "title": "IxDTW 互動設計年會 2021（實體單天統一）",
  "alias": "alias",
  "seriesNum": "seriesNum",
  "state": 1,
  "type": "physical",
  "dateType": "single",
  "chargeType": "impartial",
  "dateTimeRange": "2021/10/03(六) (08:00~22:00)",
  "registrationType": "impartial",
  "registrationStartDate": "2021-08-26 07:59:59",
  "registrationEndDate": "2022-10-02 23:59:59",
  "inProgress": 0,
  "hasAbsentLimit": 0,
  "absentLimit": 1,
  "canApply": 1,
  "basePrice": 0,
  "salePrice": 0,
  "link": "https://youtu.be/acefhx",
  "bannerImage": "banner.png",
  "slideshow": [
    {
      "path": "slideshow1.png",
      "default": 1
    },
    {
      "path": "slideshow2.png",
      "default": 0
    }
  ],
  "introtext": "設計下一個十年 - 多元與躍進",
  "description": "IxDTW 互動設計年會是 2021 年台灣主要的互動設計與使用者體驗設計的論壇。將於台北舉行，我們即將邀請 25 ~30 位來自國內外產官學界的設計專家及知名講者，分享他們的思維與經驗，以及在設計產品中所遇到的挑戰，讓會眾拓展跨職能的視野。\n\n今年，以「多元與躍進」作為大會主軸，帶領會眾共同思考下一個十年會朝那些趨勢前進，而多元文化是如何影響我們的生活及設計方式，形成新的意義。先行者們，持續躍進及挑戰的過程，將有助我們理解產業的變動，設計師將其價值轉化為設計行動，結合在地優勢面向全世界。",
  "locationName": "張榮發國際會議中心",
  "city": "臺北市",
  "district": "中正區",
  "address": "中山南路11號11樓",
  "zipcode": "101",
  "lat": 25.1234567,
  "lng": 121.02564,
  "canRegisterGroup": 7,
  "requireCoupon": 0,
  "phoneCode": "02",
  "phone": "25316628",
  "needReview": 1,
  "params": [],
  "meals": [
    {
      "id": 3,
      "date": "2021-10-03",
      "options": [
        "葷食餐點",
        "素食餐點"
      ],
      "params": []
    },
    {
      "id": 4,
      "date": "2021-10-04",
      "options": [
        "炙燒北海道干貝丼",
        "炙燒北海道干貝丼",
        "馬糞海膽散壽司"
      ],
      "params": []
    }
  ],
  "questions": [
    {
      "title": "感興趣的議題",
      "state": 1,
      "type": "select",
      "value": "",
      "required": 1,
      "description": "請選擇感興趣的議題",
      "params": {
        "options": [
          "資訊安全",
          "虛擬化",
          "AI大數據"
        ]
      }
    }
  ],
  "files": [
    {
      "uuid": "F2110Wv8",
      "categoryTitle": "課程檔案",
      "title": "課程檔案",
      "description": null,
      "size": "Bytes",
      "publishUp": null,
      "downloadLink": "http://zerone.test/api/file/download/F2110Wv8"
    }
  ],
  "sponsors": [
    {
      "title": "Microsoft",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://microsoft.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    }
  ],
  "brands": [
    {
      "title": "BlcakBerry",
      "alias": "blcakberry",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "contact": [
        {
          "name": "王小明",
          "gender": "先生",
          "countryCode": "02",
          "phone": "22221234",
          "extension": "1111"
        },
        {
          "name": "林小花",
          "gender": "先生",
          "countryCode": "02",
          "phone": "22225566",
          "extension": "2222"
        }
      ]
    },
    {
      "title": "VMware",
      "alias": "vmware",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "contact": [
        {
          "name": "王小明",
          "gender": "先生",
          "countryCode": "02",
          "phone": "22221234",
          "extension": "1111"
        },
      ]
    }
  ],
  "sessions": [
    {
      "date": "2021-10-03",
      "sessions": [
        {
          "uuid": "08724314-8b0d-4b8b-bc97-aaf5870b4725",
          "title": "年會開幕",
          "startTime": "09:30",
          "endTime": "09:45",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "開幕式",
          "description": "開幕式",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [
            {
              "uuid": "F2110Wv8",
              "categoryTitle": "課程檔案",
              "title": "課程檔案",
              "description": null,
              "size": "Bytes",
              "publishUp": null,
              "downloadLink": "http://zerone.test/api/file/download/F2110Wv8",
              "contentType": "application/pdf"
            }
          ],
          "link": null
        },
        {
          "uuid": "6f0fbac6-ea7d-4c9d-b46d-5f8840c1d826",
          "title": "Making Digital Tangible: The Battle Against the Pixel Empire",
          "startTime": "09:45",
          "endTime": "10:55",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 1,
          "linkOpeningTime": null,
          "introtext": "數位資訊實體化：一場與像素帝國抗衡的戰役",
          "description": "時下人機互動的主流研究大多關注實用層面－使用者需求、實際的應用系統，與易用性評估。Tangible Bits 和 Radical Atoms 則是願景驅動的研究，並以藝術取向執行。現今社會一項技術可能一年後就過時了，一個應用系統可能十年後就遭取代。但我們相信，一個真正的願景，能持續發揮影響超過百年。\n\nTangible Bits 的研究目的是實現打造人、數位資訊，與實體環境之間無接縫的介面（Seamless Interfaces），為數位資訊與運算提供實體介面，讓人們可以直接操控位元（bits），也能感知其存在，無論是在前景或背景意識之下（foreground and background of our consciousness）。我們的目標是發明新的設計媒介，不但能適用於科學分析，也應用在藝術表達。Tangible Bits 的研究理念除了利用即時感知與數位回饋帶來的運算呈現外，也充分利用人類豐富的感官能力，與人們ㄧ生與實體世界互動的多樣技能。",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "91312205-2007-4800-82fe-625f520c2ff0",
          "title": "休息交流時間",
          "startTime": "10:50",
          "endTime": "11:10",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": FAKE_PERSONNEL_LIST,
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "",
          "locationName": "11樓休息區",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "6bffa1c5-a89f-4468-a386-c7b448d6b2c6",
          "title": "漸進式的改革與創新 - 後疫情時代的設計體驗轉型",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "產品會隨著人們的生活一起演進，歷史悠久的產品，會發展出深根蒂固的使用習慣，企業內部也有完整的流程與堅實企業文化。然而，習慣與框架有時會成為設計師推進創新的門檻。 Lydia將透過幾個Yahoo奇摩在台灣與Verizon Media在歐洲線的產品開發實例，分享這幾年如何以體驗式設計帶領團隊走進使用者的生活，並且將同理心應用在同事和決策者身上，進而打破既有設計規範、跨國文化，讓體驗文化在組織中發酵，漸進式的改革並創造與時俱進的產品在不同市場中。\n\n我們都期待改革是快速與有效的，但很多時候使用者多年的使用體驗已經定型，Lydia 帶領的 Verizon Media 設計團隊從前期策略規劃、使用者體驗訪談到設計開發與上線後監測優化都有一套完整流程，並帶動合作部門推進創新維度與執行。本次將分享在改革的腳步中，如何加快企業內部的接受度、開發與溝通的速度，並透過設計管理，讓這樣的成功案例可以跨國推進、建立 SOP ; 更重要的是，聚沙成塔，如何有規劃與節奏的讓使用者漸進式轉移，擁抱新的體驗設計，並因應不同市場的快速變化，Lydia也將分享幾個後疫情時代，產品快速調整的實際案例。",
          "locationName": "1101",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ebe86034-7fda-464b-bebe-081f35d9703a",
          "title": "設計作為一種推測與思想實驗",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            },
            {
              "name": "王小明2",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "「我們的現實世界被無垠的可能世界所包圍。」\n\nLubomír Doležel, Heterocosmica: Fiction and Possible Worlds, 1999\n2005年從英國皇家藝術學院（Royal College of Art）設計互動系（Design Interactions）開始慢慢萌芽的推測設計（Speculative Design）思維，經過十幾年之後，近年來在西方世界的設計、藝術文化領域，引起了廣大的影響與辯論，而很多專家也認為推測設計是「推測未來」的重要方法之一，而在東方世界，這股氛圍也緩緩升起中。\n\n「設計」如何作為一種推測、如何作為一種思想實驗？本次講座的講者宮保睿，試著帶領你從推測設計的發源起點、思維方式、現在狀況、可能未來、創作與教學實踐來解析各種面向，試著讓我們透過推測設計思維去思考著當面對未知未來時，「這個世界可能會變成什麼樣子？」這個重要的提問。",
          "locationName": "1102",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ae14e984-b8a3-4c44-abd9-1ea32ee37583",
          "title": "春池循環設計的各種實踐與未來",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "在氣候變遷與溫室效應影響著我們的生活，循環經濟與循環設計變成一個重要未來課題。 「我們過去的需求都是消耗，但我們想塑造的未來是，把未來的需求都成為新的創造。」春池玻璃未來將繼續以循環玻璃為載體，希望影響更多產業走向循環經濟。\n\n春池玻璃，目前跨足於工業原料、科技建材、文化藝術與觀光工廠。本業為專業回收玻璃與再處理之企業，總公司在台灣新竹，並擁有三家相關企業。目前每年回收並處理超過 10 萬噸的春池玻璃，目前為全台最具規模之廢棄玻璃回收業者。其企業理念為永續經營，綠色創新。在 2015 更獲得根留台灣，展望全球之「金根獎」之殊榮。蔡總統英文更在 2016 年 9 月親自參訪春池玻璃觀光工廠，並給予極高評價，稱春池玻璃為台灣「循環經濟」之典範。更在 2017 年獲得 British Chamber of Commerce 之 Better Business Award 社會企業首獎。更在 2018 年獲得總統創新獎與艾森豪獎金學人殊榮",
          "locationName": "1103",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        }
      ]
    },
  ]
};

// 實體 單天 分場次報名
export const FAKE_EVENT_ITEM_PHYSICAL_SINGLE_PARTIAL = {
  "title": "IxDTW 互動設計年會 2021（實體單天分場次）",
  "alias": "alias",
  "seriesNum": "seriesNum",
  "state": 1,
  "type": "physical", // 實體
  "dateType": "single", // 單天
  "chargeType": "impartial",
  "dateTimeRange": "2021/10/03(六) (08:00~22:00)",
  "registrationType": "partial", // 分場次
  "registrationStartDate": "2021-08-26 07:59:59",
  "registrationEndDate": "2022-10-02 23:59:59",
  "inProgress": 0,
  "hasAbsentLimit": 0,
  "absentLimit": 1,
  "canApply": 1,
  "basePrice": 0,
  "salePrice": 0,
  "link": "https://youtu.be/acefhx",
  "bannerImage": "banner.png",
  "slideshow": [
    {
      "path": "slideshow1.png",
      "default": 1
    },
    {
      "path": "slideshow2.png",
      "default": 0
    }
  ],
  "introtext": "設計下一個十年 - 多元與躍進",
  "description": "IxDTW 互動設計年會是 2021 年台灣主要的互動設計與使用者體驗設計的論壇。將於台北舉行，我們即將邀請 25 ~30 位來自國內外產官學界的設計專家及知名講者，分享他們的思維與經驗，以及在設計產品中所遇到的挑戰，讓會眾拓展跨職能的視野。\n\n今年，以「多元與躍進」作為大會主軸，帶領會眾共同思考下一個十年會朝那些趨勢前進，而多元文化是如何影響我們的生活及設計方式，形成新的意義。先行者們，持續躍進及挑戰的過程，將有助我們理解產業的變動，設計師將其價值轉化為設計行動，結合在地優勢面向全世界。",
  "locationName": "張榮發國際會議中心",
  "city": "臺北市",
  "district": "中正區",
  "address": "中山南路11號11樓",
  "zipcode": "101",
  "lat": 25.1234567,
  "lng": 121.02564,
  "canRegisterGroup": 7,
  "requireCoupon": 1,
  "phoneCode": "02",
  "phone": "25316628",
  "needReview": 1,
  "params": [],
  "meals": [
    {
      "id": 3,
      "date": "2021-10-03",
      "options": [
        "葷食餐點",
        "素食餐點"
      ],
      "params": []
    },
    {
      "id": 4,
      "date": "2021-10-04",
      "options": [
        "炙燒北海道干貝丼",
        "炙燒北海道干貝丼",
        "馬糞海膽散壽司"
      ],
      "params": []
    }
  ],
  "questions": [
    {
      "title": "感興趣的議題",
      "state": 1,
      "type": "select",
      "value": "",
      "required": 1,
      "description": "請選擇感興趣的議題",
      "params": {
        "options": [
          "資訊安全",
          "虛擬化",
          "AI大數據"
        ]
      }
    }
  ],
  "files": [
    {
      "uuid": "F2110Wv8",
      "categoryTitle": "課程檔案",
      "title": "課程檔案",
      "description": null,
      "size": "Bytes",
      "publishUp": null,
      "downloadLink": "http://zerone.test/api/file/download/F2110Wv8"
    }
  ],
  "sponsors": [
    {
      "title": "Microsoft",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://microsoft.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    }
  ],
  "brands": [
    {
      "title": "BlcakBerry",
      "alias": "blcakberry",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "contact": [
        {
          "name": "王小明",
          "gender": "先生",
          "countryCode": "02",
          "phone": "22221234",
          "extension": "1111"
        },
        {
          "name": "林小花",
          "gender": "先生",
          "countryCode": "02",
          "phone": "22225566",
          "extension": "2222"
        }
      ]
    },
    {
      "title": "VMware",
      "alias": "vmware",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "contact": [
        {
          "name": "王小明",
          "gender": "先生",
          "countryCode": "02",
          "phone": "22221234",
          "extension": "1111"
        },
      ]
    }
  ],
  "sessions": [
    {
      "date": "2021-10-03",
      "sessions": [
        {
          "uuid": "08724314-8b0d-4b8b-bc97-aaf5870b4725",
          "title": "年會開幕",
          "startTime": "09:30",
          "endTime": "09:45",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "開幕式",
          "description": "開幕式",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [
            {
              "uuid": "F2110Wv8",
              "categoryTitle": "課程檔案",
              "title": "課程檔案",
              "description": null,
              "size": "Bytes",
              "publishUp": null,
              "downloadLink": "http://zerone.test/api/file/download/F2110Wv8",
              "contentType": "application/pdf"
            }
          ],
          "link": null
        },
        {
          "uuid": "6f0fbac6-ea7d-4c9d-b46d-5f8840c1d826",
          "title": "Making Digital Tangible: The Battle Against the Pixel Empire",
          "startTime": "09:45",
          "endTime": "10:55",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 1,
          "linkOpeningTime": null,
          "introtext": "數位資訊實體化：一場與像素帝國抗衡的戰役",
          "description": "時下人機互動的主流研究大多關注實用層面－使用者需求、實際的應用系統，與易用性評估。Tangible Bits 和 Radical Atoms 則是願景驅動的研究，並以藝術取向執行。現今社會一項技術可能一年後就過時了，一個應用系統可能十年後就遭取代。但我們相信，一個真正的願景，能持續發揮影響超過百年。\n\nTangible Bits 的研究目的是實現打造人、數位資訊，與實體環境之間無接縫的介面（Seamless Interfaces），為數位資訊與運算提供實體介面，讓人們可以直接操控位元（bits），也能感知其存在，無論是在前景或背景意識之下（foreground and background of our consciousness）。我們的目標是發明新的設計媒介，不但能適用於科學分析，也應用在藝術表達。Tangible Bits 的研究理念除了利用即時感知與數位回饋帶來的運算呈現外，也充分利用人類豐富的感官能力，與人們ㄧ生與實體世界互動的多樣技能。",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "91312205-2007-4800-82fe-625f520c2ff0",
          "title": "休息交流時間",
          "startTime": "10:50",
          "endTime": "11:10",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "",
          "locationName": "11樓休息區",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "6bffa1c5-a89f-4468-a386-c7b448d6b2c6",
          "title": "漸進式的改革與創新 - 後疫情時代的設計體驗轉型",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 1,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "產品會隨著人們的生活一起演進，歷史悠久的產品，會發展出深根蒂固的使用習慣，企業內部也有完整的流程與堅實企業文化。然而，習慣與框架有時會成為設計師推進創新的門檻。 Lydia將透過幾個Yahoo奇摩在台灣與Verizon Media在歐洲線的產品開發實例，分享這幾年如何以體驗式設計帶領團隊走進使用者的生活，並且將同理心應用在同事和決策者身上，進而打破既有設計規範、跨國文化，讓體驗文化在組織中發酵，漸進式的改革並創造與時俱進的產品在不同市場中。\n\n我們都期待改革是快速與有效的，但很多時候使用者多年的使用體驗已經定型，Lydia 帶領的 Verizon Media 設計團隊從前期策略規劃、使用者體驗訪談到設計開發與上線後監測優化都有一套完整流程，並帶動合作部門推進創新維度與執行。本次將分享在改革的腳步中，如何加快企業內部的接受度、開發與溝通的速度，並透過設計管理，讓這樣的成功案例可以跨國推進、建立 SOP ; 更重要的是，聚沙成塔，如何有規劃與節奏的讓使用者漸進式轉移，擁抱新的體驗設計，並因應不同市場的快速變化，Lydia也將分享幾個後疫情時代，產品快速調整的實際案例。",
          "locationName": "1101",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ebe86034-7fda-464b-bebe-081f35d9703a",
          "title": "設計作為一種推測與思想實驗",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            },
            {
              "name": "王小明2",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "「我們的現實世界被無垠的可能世界所包圍。」\n\nLubomír Doležel, Heterocosmica: Fiction and Possible Worlds, 1999\n2005年從英國皇家藝術學院（Royal College of Art）設計互動系（Design Interactions）開始慢慢萌芽的推測設計（Speculative Design）思維，經過十幾年之後，近年來在西方世界的設計、藝術文化領域，引起了廣大的影響與辯論，而很多專家也認為推測設計是「推測未來」的重要方法之一，而在東方世界，這股氛圍也緩緩升起中。\n\n「設計」如何作為一種推測、如何作為一種思想實驗？本次講座的講者宮保睿，試著帶領你從推測設計的發源起點、思維方式、現在狀況、可能未來、創作與教學實踐來解析各種面向，試著讓我們透過推測設計思維去思考著當面對未知未來時，「這個世界可能會變成什麼樣子？」這個重要的提問。",
          "locationName": "1102",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ae14e984-b8a3-4c44-abd9-1ea32ee37583",
          "title": "春池循環設計的各種實踐與未來",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "在氣候變遷與溫室效應影響著我們的生活，循環經濟與循環設計變成一個重要未來課題。 「我們過去的需求都是消耗，但我們想塑造的未來是，把未來的需求都成為新的創造。」春池玻璃未來將繼續以循環玻璃為載體，希望影響更多產業走向循環經濟。\n\n春池玻璃，目前跨足於工業原料、科技建材、文化藝術與觀光工廠。本業為專業回收玻璃與再處理之企業，總公司在台灣新竹，並擁有三家相關企業。目前每年回收並處理超過 10 萬噸的春池玻璃，目前為全台最具規模之廢棄玻璃回收業者。其企業理念為永續經營，綠色創新。在 2015 更獲得根留台灣，展望全球之「金根獎」之殊榮。蔡總統英文更在 2016 年 9 月親自參訪春池玻璃觀光工廠，並給予極高評價，稱春池玻璃為台灣「循環經濟」之典範。更在 2017 年獲得 British Chamber of Commerce 之 Better Business Award 社會企業首獎。更在 2018 年獲得總統創新獎與艾森豪獎金學人殊榮",
          "locationName": "1103",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        }
      ]
    },
  ]
};

// 實體 多天 統一報名
export const FAKE_EVENT_ITEM_PHYSICAL_MULTIPLE_IMPARTIAL = {
  "title": "IxDTW 互動設計年會 2021（實體多天統一）",
  "alias": "alias",
  "seriesNum": "seriesNum",
  "state": 1,
  "type": "physical", // 實體
  "dateType": "multiple", // 多天
  "chargeType": "impartial",
  "dateTimeRange": "2021/10/03(六) (08:00~22:00)",
  "registrationType": "impartial", // 統一
  "registrationStartDate": "2021-08-26 07:59:59",
  "registrationEndDate": "2022-10-02 23:59:59",
  "inProgress": 0,
  "hasAbsentLimit": 0,
  "absentLimit": 1,
  "canApply": 0,
  "basePrice": 0,
  "salePrice": 0,
  "link": "https://youtu.be/acefhx",
  "bannerImage": "banner.png",
  "slideshow": [
    {
      "path": "slideshow1.png",
      "default": 1
    },
    {
      "path": "slideshow2.png",
      "default": 0
    }
  ],
  "introtext": "設計下一個十年 - 多元與躍進",
  "description": "IxDTW 互動設計年會是 2021 年台灣主要的互動設計與使用者體驗設計的論壇。將於台北舉行，我們即將邀請 25 ~30 位來自國內外產官學界的設計專家及知名講者，分享他們的思維與經驗，以及在設計產品中所遇到的挑戰，讓會眾拓展跨職能的視野。\n\n今年，以「多元與躍進」作為大會主軸，帶領會眾共同思考下一個十年會朝那些趨勢前進，而多元文化是如何影響我們的生活及設計方式，形成新的意義。先行者們，持續躍進及挑戰的過程，將有助我們理解產業的變動，設計師將其價值轉化為設計行動，結合在地優勢面向全世界。",
  "locationName": "張榮發國際會議中心",
  "city": "臺北市",
  "district": "中正區",
  "address": "中山南路11號11樓",
  "zipcode": "101",
  "lat": 25.1234567,
  "lng": 121.02564,
  "canRegisterGroup": 7,
  "requireCoupon": 1,
  "phoneCode": "02",
  "phone": "25316628",
  "needReview": 1,
  "params": [],
  "meals": [
    {
      "id": 3,
      "date": "2021-10-03",
      "options": [
        "葷食餐點",
        "素食餐點"
      ],
      "params": []
    },
    {
      "id": 4,
      "date": "2021-10-04",
      "options": [
        "炙燒北海道干貝丼",
        "炙燒北海道干貝丼",
        "馬糞海膽散壽司"
      ],
      "params": []
    },
    {
      "id": 5,
      "date": "2021-10-05",
      "options": [
        "炙燒北海道干貝丼",
        "炙燒北海道干貝丼",
        "馬糞海膽散壽司"
      ],
      "params": []
    },
    {
      "id": 6,
      "date": "2021-10-06",
      "options": [
        "炙燒北海道干貝丼",
        "炙燒北海道干貝丼",
        "馬糞海膽散壽司"
      ],
      "params": []
    },
    {
      "id": 7,
      "date": "2021-10-07",
      "options": [
        "炙燒北海道干貝丼",
        "炙燒北海道干貝丼",
        "馬糞海膽散壽司"
      ],
      "params": []
    },
    {
      "id": 8,
      "date": "2021-10-08",
      "options": [
        "炙燒北海道干貝丼",
        "炙燒北海道干貝丼",
        "馬糞海膽散壽司"
      ],
      "params": []
    }
  ],
  "questions": [
    {
      "title": "感興趣的議題",
      "state": 1,
      "type": "select",
      "value": "",
      "required": 1,
      "description": "請選擇感興趣的議題",
      "params": {
        "options": [
          "資訊安全",
          "虛擬化",
          "AI大數據"
        ]
      }
    }
  ],
  "files": [
    {
      "uuid": "F2110Wv8",
      "categoryTitle": "課程檔案",
      "title": "課程檔案",
      "description": null,
      "size": "Bytes",
      "publishUp": null,
      "downloadLink": "http://zerone.test/api/file/download/F2110Wv8"
    }
  ],
  "sponsors": [
    {
      "title": "Microsoft",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://microsoft.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    }
  ],
  "brands": [
    {
      "title": "BlcakBerry",
      "alias": "blcakberry",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "contact": [
        {
          "name": "王小明",
          "gender": "先生",
          "countryCode": "02",
          "phone": "22221234",
          "extension": "1111"
        },
        {
          "name": "林小花",
          "gender": "先生",
          "countryCode": "02",
          "phone": "22225566",
          "extension": "2222"
        }
      ]
    },
    {
      "title": "VMware",
      "alias": "vmware",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "contact": [
        {
          "name": "王小明",
          "gender": "先生",
          "countryCode": "02",
          "phone": "22221234",
          "extension": "1111"
        },
      ]
    }
  ],
  "sessions": [
    {
      "date": "2021-10-03",
      "sessions": [
        {
          "uuid": "08724314-8b0d-4b8b-bc97-aaf5870b4725",
          "title": "年會開幕",
          "startTime": "09:30",
          "endTime": "09:45",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "開幕式",
          "description": "開幕式",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [
            {
              "uuid": "F2110Wv8",
              "categoryTitle": "課程檔案",
              "title": "課程檔案",
              "description": null,
              "size": "Bytes",
              "publishUp": null,
              "downloadLink": "http://zerone.test/api/file/download/F2110Wv8",
              "contentType": "application/pdf"
            }
          ],
          "link": null
        },
        {
          "uuid": "6f0fbac6-ea7d-4c9d-b46d-5f8840c1d826",
          "title": "Making Digital Tangible: The Battle Against the Pixel Empire",
          "startTime": "09:45",
          "endTime": "10:55",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 1,
          "linkOpeningTime": null,
          "introtext": "數位資訊實體化：一場與像素帝國抗衡的戰役",
          "description": "時下人機互動的主流研究大多關注實用層面－使用者需求、實際的應用系統，與易用性評估。Tangible Bits 和 Radical Atoms 則是願景驅動的研究，並以藝術取向執行。現今社會一項技術可能一年後就過時了，一個應用系統可能十年後就遭取代。但我們相信，一個真正的願景，能持續發揮影響超過百年。\n\nTangible Bits 的研究目的是實現打造人、數位資訊，與實體環境之間無接縫的介面（Seamless Interfaces），為數位資訊與運算提供實體介面，讓人們可以直接操控位元（bits），也能感知其存在，無論是在前景或背景意識之下（foreground and background of our consciousness）。我們的目標是發明新的設計媒介，不但能適用於科學分析，也應用在藝術表達。Tangible Bits 的研究理念除了利用即時感知與數位回饋帶來的運算呈現外，也充分利用人類豐富的感官能力，與人們ㄧ生與實體世界互動的多樣技能。",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "91312205-2007-4800-82fe-625f520c2ff0",
          "title": "休息交流時間",
          "startTime": "10:50",
          "endTime": "11:10",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "",
          "locationName": "11樓休息區",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "6bffa1c5-a89f-4468-a386-c7b448d6b2c6",
          "title": "漸進式的改革與創新 - 後疫情時代的設計體驗轉型",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "產品會隨著人們的生活一起演進，歷史悠久的產品，會發展出深根蒂固的使用習慣，企業內部也有完整的流程與堅實企業文化。然而，習慣與框架有時會成為設計師推進創新的門檻。 Lydia將透過幾個Yahoo奇摩在台灣與Verizon Media在歐洲線的產品開發實例，分享這幾年如何以體驗式設計帶領團隊走進使用者的生活，並且將同理心應用在同事和決策者身上，進而打破既有設計規範、跨國文化，讓體驗文化在組織中發酵，漸進式的改革並創造與時俱進的產品在不同市場中。\n\n我們都期待改革是快速與有效的，但很多時候使用者多年的使用體驗已經定型，Lydia 帶領的 Verizon Media 設計團隊從前期策略規劃、使用者體驗訪談到設計開發與上線後監測優化都有一套完整流程，並帶動合作部門推進創新維度與執行。本次將分享在改革的腳步中，如何加快企業內部的接受度、開發與溝通的速度，並透過設計管理，讓這樣的成功案例可以跨國推進、建立 SOP ; 更重要的是，聚沙成塔，如何有規劃與節奏的讓使用者漸進式轉移，擁抱新的體驗設計，並因應不同市場的快速變化，Lydia也將分享幾個後疫情時代，產品快速調整的實際案例。",
          "locationName": "1101",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ebe86034-7fda-464b-bebe-081f35d9703a",
          "title": "設計作為一種推測與思想實驗",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            },
            {
              "name": "王小明2",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "「我們的現實世界被無垠的可能世界所包圍。」\n\nLubomír Doležel, Heterocosmica: Fiction and Possible Worlds, 1999\n2005年從英國皇家藝術學院（Royal College of Art）設計互動系（Design Interactions）開始慢慢萌芽的推測設計（Speculative Design）思維，經過十幾年之後，近年來在西方世界的設計、藝術文化領域，引起了廣大的影響與辯論，而很多專家也認為推測設計是「推測未來」的重要方法之一，而在東方世界，這股氛圍也緩緩升起中。\n\n「設計」如何作為一種推測、如何作為一種思想實驗？本次講座的講者宮保睿，試著帶領你從推測設計的發源起點、思維方式、現在狀況、可能未來、創作與教學實踐來解析各種面向，試著讓我們透過推測設計思維去思考著當面對未知未來時，「這個世界可能會變成什麼樣子？」這個重要的提問。",
          "locationName": "1102",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ae14e984-b8a3-4c44-abd9-1ea32ee37583",
          "title": "春池循環設計的各種實踐與未來",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "在氣候變遷與溫室效應影響著我們的生活，循環經濟與循環設計變成一個重要未來課題。 「我們過去的需求都是消耗，但我們想塑造的未來是，把未來的需求都成為新的創造。」春池玻璃未來將繼續以循環玻璃為載體，希望影響更多產業走向循環經濟。\n\n春池玻璃，目前跨足於工業原料、科技建材、文化藝術與觀光工廠。本業為專業回收玻璃與再處理之企業，總公司在台灣新竹，並擁有三家相關企業。目前每年回收並處理超過 10 萬噸的春池玻璃，目前為全台最具規模之廢棄玻璃回收業者。其企業理念為永續經營，綠色創新。在 2015 更獲得根留台灣，展望全球之「金根獎」之殊榮。蔡總統英文更在 2016 年 9 月親自參訪春池玻璃觀光工廠，並給予極高評價，稱春池玻璃為台灣「循環經濟」之典範。更在 2017 年獲得 British Chamber of Commerce 之 Better Business Award 社會企業首獎。更在 2018 年獲得總統創新獎與艾森豪獎金學人殊榮",
          "locationName": "1103",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        }
      ]
    },
    {
      "date": "2021-10-04",
      "sessions": [
        {
          "uuid": "08724314-8b0d-4b8b-bc97-aaf5870b4725",
          "title": "04年會開幕",
          "startTime": "09:30",
          "endTime": "09:45",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "開幕式",
          "description": "開幕式",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [
            {
              "uuid": "F2110Wv8",
              "categoryTitle": "課程檔案",
              "title": "課程檔案",
              "description": null,
              "size": "Bytes",
              "publishUp": null,
              "downloadLink": "http://zerone.test/api/file/download/F2110Wv8",
              "contentType": "application/pdf"
            }
          ],
          "link": null
        },
        {
          "uuid": "6f0fbac6-ea7d-4c9d-b46d-5f8840c1d826",
          "title": "Making Digital Tangible: The Battle Against the Pixel Empire",
          "startTime": "09:45",
          "endTime": "10:55",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 1,
          "linkOpeningTime": null,
          "introtext": "數位資訊實體化：一場與像素帝國抗衡的戰役",
          "description": "時下人機互動的主流研究大多關注實用層面－使用者需求、實際的應用系統，與易用性評估。Tangible Bits 和 Radical Atoms 則是願景驅動的研究，並以藝術取向執行。現今社會一項技術可能一年後就過時了，一個應用系統可能十年後就遭取代。但我們相信，一個真正的願景，能持續發揮影響超過百年。\n\nTangible Bits 的研究目的是實現打造人、數位資訊，與實體環境之間無接縫的介面（Seamless Interfaces），為數位資訊與運算提供實體介面，讓人們可以直接操控位元（bits），也能感知其存在，無論是在前景或背景意識之下（foreground and background of our consciousness）。我們的目標是發明新的設計媒介，不但能適用於科學分析，也應用在藝術表達。Tangible Bits 的研究理念除了利用即時感知與數位回饋帶來的運算呈現外，也充分利用人類豐富的感官能力，與人們ㄧ生與實體世界互動的多樣技能。",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "91312205-2007-4800-82fe-625f520c2ff0",
          "title": "休息交流時間",
          "startTime": "10:50",
          "endTime": "11:10",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "",
          "locationName": "11樓休息區",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "6bffa1c5-a89f-4468-a386-c7b448d6b2c6",
          "title": "漸進式的改革與創新 - 後疫情時代的設計體驗轉型",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "產品會隨著人們的生活一起演進，歷史悠久的產品，會發展出深根蒂固的使用習慣，企業內部也有完整的流程與堅實企業文化。然而，習慣與框架有時會成為設計師推進創新的門檻。 Lydia將透過幾個Yahoo奇摩在台灣與Verizon Media在歐洲線的產品開發實例，分享這幾年如何以體驗式設計帶領團隊走進使用者的生活，並且將同理心應用在同事和決策者身上，進而打破既有設計規範、跨國文化，讓體驗文化在組織中發酵，漸進式的改革並創造與時俱進的產品在不同市場中。\n\n我們都期待改革是快速與有效的，但很多時候使用者多年的使用體驗已經定型，Lydia 帶領的 Verizon Media 設計團隊從前期策略規劃、使用者體驗訪談到設計開發與上線後監測優化都有一套完整流程，並帶動合作部門推進創新維度與執行。本次將分享在改革的腳步中，如何加快企業內部的接受度、開發與溝通的速度，並透過設計管理，讓這樣的成功案例可以跨國推進、建立 SOP ; 更重要的是，聚沙成塔，如何有規劃與節奏的讓使用者漸進式轉移，擁抱新的體驗設計，並因應不同市場的快速變化，Lydia也將分享幾個後疫情時代，產品快速調整的實際案例。",
          "locationName": "1101",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ebe86034-7fda-464b-bebe-081f35d9703a",
          "title": "設計作為一種推測與思想實驗",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            },
            {
              "name": "王小明2",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "「我們的現實世界被無垠的可能世界所包圍。」\n\nLubomír Doležel, Heterocosmica: Fiction and Possible Worlds, 1999\n2005年從英國皇家藝術學院（Royal College of Art）設計互動系（Design Interactions）開始慢慢萌芽的推測設計（Speculative Design）思維，經過十幾年之後，近年來在西方世界的設計、藝術文化領域，引起了廣大的影響與辯論，而很多專家也認為推測設計是「推測未來」的重要方法之一，而在東方世界，這股氛圍也緩緩升起中。\n\n「設計」如何作為一種推測、如何作為一種思想實驗？本次講座的講者宮保睿，試著帶領你從推測設計的發源起點、思維方式、現在狀況、可能未來、創作與教學實踐來解析各種面向，試著讓我們透過推測設計思維去思考著當面對未知未來時，「這個世界可能會變成什麼樣子？」這個重要的提問。",
          "locationName": "1102",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ae14e984-b8a3-4c44-abd9-1ea32ee37583",
          "title": "春池循環設計的各種實踐與未來",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "在氣候變遷與溫室效應影響著我們的生活，循環經濟與循環設計變成一個重要未來課題。 「我們過去的需求都是消耗，但我們想塑造的未來是，把未來的需求都成為新的創造。」春池玻璃未來將繼續以循環玻璃為載體，希望影響更多產業走向循環經濟。\n\n春池玻璃，目前跨足於工業原料、科技建材、文化藝術與觀光工廠。本業為專業回收玻璃與再處理之企業，總公司在台灣新竹，並擁有三家相關企業。目前每年回收並處理超過 10 萬噸的春池玻璃，目前為全台最具規模之廢棄玻璃回收業者。其企業理念為永續經營，綠色創新。在 2015 更獲得根留台灣，展望全球之「金根獎」之殊榮。蔡總統英文更在 2016 年 9 月親自參訪春池玻璃觀光工廠，並給予極高評價，稱春池玻璃為台灣「循環經濟」之典範。更在 2017 年獲得 British Chamber of Commerce 之 Better Business Award 社會企業首獎。更在 2018 年獲得總統創新獎與艾森豪獎金學人殊榮",
          "locationName": "1103",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        }
      ]
    },
    {
      "date": "2021-10-05",
      "sessions": [
        {
          "uuid": "08724314-8b0d-4b8b-bc97-aaf5870b4725",
          "title": "05年會開幕",
          "startTime": "09:30",
          "endTime": "09:45",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "開幕式",
          "description": "開幕式",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [
            {
              "uuid": "F2110Wv8",
              "categoryTitle": "課程檔案",
              "title": "課程檔案",
              "description": null,
              "size": "Bytes",
              "publishUp": null,
              "downloadLink": "http://zerone.test/api/file/download/F2110Wv8",
              "contentType": "application/pdf"
            }
          ],
          "link": null
        },
        {
          "uuid": "6f0fbac6-ea7d-4c9d-b46d-5f8840c1d826",
          "title": "Making Digital Tangible: The Battle Against the Pixel Empire",
          "startTime": "09:45",
          "endTime": "10:55",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 1,
          "linkOpeningTime": null,
          "introtext": "數位資訊實體化：一場與像素帝國抗衡的戰役",
          "description": "時下人機互動的主流研究大多關注實用層面－使用者需求、實際的應用系統，與易用性評估。Tangible Bits 和 Radical Atoms 則是願景驅動的研究，並以藝術取向執行。現今社會一項技術可能一年後就過時了，一個應用系統可能十年後就遭取代。但我們相信，一個真正的願景，能持續發揮影響超過百年。\n\nTangible Bits 的研究目的是實現打造人、數位資訊，與實體環境之間無接縫的介面（Seamless Interfaces），為數位資訊與運算提供實體介面，讓人們可以直接操控位元（bits），也能感知其存在，無論是在前景或背景意識之下（foreground and background of our consciousness）。我們的目標是發明新的設計媒介，不但能適用於科學分析，也應用在藝術表達。Tangible Bits 的研究理念除了利用即時感知與數位回饋帶來的運算呈現外，也充分利用人類豐富的感官能力，與人們ㄧ生與實體世界互動的多樣技能。",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "91312205-2007-4800-82fe-625f520c2ff0",
          "title": "休息交流時間",
          "startTime": "10:50",
          "endTime": "11:10",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "",
          "locationName": "11樓休息區",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "6bffa1c5-a89f-4468-a386-c7b448d6b2c6",
          "title": "漸進式的改革與創新 - 後疫情時代的設計體驗轉型",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "產品會隨著人們的生活一起演進，歷史悠久的產品，會發展出深根蒂固的使用習慣，企業內部也有完整的流程與堅實企業文化。然而，習慣與框架有時會成為設計師推進創新的門檻。 Lydia將透過幾個Yahoo奇摩在台灣與Verizon Media在歐洲線的產品開發實例，分享這幾年如何以體驗式設計帶領團隊走進使用者的生活，並且將同理心應用在同事和決策者身上，進而打破既有設計規範、跨國文化，讓體驗文化在組織中發酵，漸進式的改革並創造與時俱進的產品在不同市場中。\n\n我們都期待改革是快速與有效的，但很多時候使用者多年的使用體驗已經定型，Lydia 帶領的 Verizon Media 設計團隊從前期策略規劃、使用者體驗訪談到設計開發與上線後監測優化都有一套完整流程，並帶動合作部門推進創新維度與執行。本次將分享在改革的腳步中，如何加快企業內部的接受度、開發與溝通的速度，並透過設計管理，讓這樣的成功案例可以跨國推進、建立 SOP ; 更重要的是，聚沙成塔，如何有規劃與節奏的讓使用者漸進式轉移，擁抱新的體驗設計，並因應不同市場的快速變化，Lydia也將分享幾個後疫情時代，產品快速調整的實際案例。",
          "locationName": "1101",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ebe86034-7fda-464b-bebe-081f35d9703a",
          "title": "設計作為一種推測與思想實驗",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            },
            {
              "name": "王小明2",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "「我們的現實世界被無垠的可能世界所包圍。」\n\nLubomír Doležel, Heterocosmica: Fiction and Possible Worlds, 1999\n2005年從英國皇家藝術學院（Royal College of Art）設計互動系（Design Interactions）開始慢慢萌芽的推測設計（Speculative Design）思維，經過十幾年之後，近年來在西方世界的設計、藝術文化領域，引起了廣大的影響與辯論，而很多專家也認為推測設計是「推測未來」的重要方法之一，而在東方世界，這股氛圍也緩緩升起中。\n\n「設計」如何作為一種推測、如何作為一種思想實驗？本次講座的講者宮保睿，試著帶領你從推測設計的發源起點、思維方式、現在狀況、可能未來、創作與教學實踐來解析各種面向，試著讓我們透過推測設計思維去思考著當面對未知未來時，「這個世界可能會變成什麼樣子？」這個重要的提問。",
          "locationName": "1102",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ae14e984-b8a3-4c44-abd9-1ea32ee37583",
          "title": "春池循環設計的各種實踐與未來",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "在氣候變遷與溫室效應影響著我們的生活，循環經濟與循環設計變成一個重要未來課題。 「我們過去的需求都是消耗，但我們想塑造的未來是，把未來的需求都成為新的創造。」春池玻璃未來將繼續以循環玻璃為載體，希望影響更多產業走向循環經濟。\n\n春池玻璃，目前跨足於工業原料、科技建材、文化藝術與觀光工廠。本業為專業回收玻璃與再處理之企業，總公司在台灣新竹，並擁有三家相關企業。目前每年回收並處理超過 10 萬噸的春池玻璃，目前為全台最具規模之廢棄玻璃回收業者。其企業理念為永續經營，綠色創新。在 2015 更獲得根留台灣，展望全球之「金根獎」之殊榮。蔡總統英文更在 2016 年 9 月親自參訪春池玻璃觀光工廠，並給予極高評價，稱春池玻璃為台灣「循環經濟」之典範。更在 2017 年獲得 British Chamber of Commerce 之 Better Business Award 社會企業首獎。更在 2018 年獲得總統創新獎與艾森豪獎金學人殊榮",
          "locationName": "1103",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        }
      ]
    },
    {
      "date": "2021-10-06",
      "sessions": [
        {
          "uuid": "08724314-8b0d-4b8b-bc97-aaf5870b4725",
          "title": "06年會開幕",
          "startTime": "09:30",
          "endTime": "09:45",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "開幕式",
          "description": "開幕式",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [
            {
              "uuid": "F2110Wv8",
              "categoryTitle": "課程檔案",
              "title": "課程檔案",
              "description": null,
              "size": "Bytes",
              "publishUp": null,
              "downloadLink": "http://zerone.test/api/file/download/F2110Wv8",
              "contentType": "application/pdf"
            }
          ],
          "link": null
        },
        {
          "uuid": "6f0fbac6-ea7d-4c9d-b46d-5f8840c1d826",
          "title": "Making Digital Tangible: The Battle Against the Pixel Empire",
          "startTime": "09:45",
          "endTime": "10:55",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 1,
          "linkOpeningTime": null,
          "introtext": "數位資訊實體化：一場與像素帝國抗衡的戰役",
          "description": "時下人機互動的主流研究大多關注實用層面－使用者需求、實際的應用系統，與易用性評估。Tangible Bits 和 Radical Atoms 則是願景驅動的研究，並以藝術取向執行。現今社會一項技術可能一年後就過時了，一個應用系統可能十年後就遭取代。但我們相信，一個真正的願景，能持續發揮影響超過百年。\n\nTangible Bits 的研究目的是實現打造人、數位資訊，與實體環境之間無接縫的介面（Seamless Interfaces），為數位資訊與運算提供實體介面，讓人們可以直接操控位元（bits），也能感知其存在，無論是在前景或背景意識之下（foreground and background of our consciousness）。我們的目標是發明新的設計媒介，不但能適用於科學分析，也應用在藝術表達。Tangible Bits 的研究理念除了利用即時感知與數位回饋帶來的運算呈現外，也充分利用人類豐富的感官能力，與人們ㄧ生與實體世界互動的多樣技能。",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "91312205-2007-4800-82fe-625f520c2ff0",
          "title": "休息交流時間",
          "startTime": "10:50",
          "endTime": "11:10",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "",
          "locationName": "11樓休息區",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "6bffa1c5-a89f-4468-a386-c7b448d6b2c6",
          "title": "漸進式的改革與創新 - 後疫情時代的設計體驗轉型",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "產品會隨著人們的生活一起演進，歷史悠久的產品，會發展出深根蒂固的使用習慣，企業內部也有完整的流程與堅實企業文化。然而，習慣與框架有時會成為設計師推進創新的門檻。 Lydia將透過幾個Yahoo奇摩在台灣與Verizon Media在歐洲線的產品開發實例，分享這幾年如何以體驗式設計帶領團隊走進使用者的生活，並且將同理心應用在同事和決策者身上，進而打破既有設計規範、跨國文化，讓體驗文化在組織中發酵，漸進式的改革並創造與時俱進的產品在不同市場中。\n\n我們都期待改革是快速與有效的，但很多時候使用者多年的使用體驗已經定型，Lydia 帶領的 Verizon Media 設計團隊從前期策略規劃、使用者體驗訪談到設計開發與上線後監測優化都有一套完整流程，並帶動合作部門推進創新維度與執行。本次將分享在改革的腳步中，如何加快企業內部的接受度、開發與溝通的速度，並透過設計管理，讓這樣的成功案例可以跨國推進、建立 SOP ; 更重要的是，聚沙成塔，如何有規劃與節奏的讓使用者漸進式轉移，擁抱新的體驗設計，並因應不同市場的快速變化，Lydia也將分享幾個後疫情時代，產品快速調整的實際案例。",
          "locationName": "1101",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ebe86034-7fda-464b-bebe-081f35d9703a",
          "title": "設計作為一種推測與思想實驗",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            },
            {
              "name": "王小明2",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "「我們的現實世界被無垠的可能世界所包圍。」\n\nLubomír Doležel, Heterocosmica: Fiction and Possible Worlds, 1999\n2005年從英國皇家藝術學院（Royal College of Art）設計互動系（Design Interactions）開始慢慢萌芽的推測設計（Speculative Design）思維，經過十幾年之後，近年來在西方世界的設計、藝術文化領域，引起了廣大的影響與辯論，而很多專家也認為推測設計是「推測未來」的重要方法之一，而在東方世界，這股氛圍也緩緩升起中。\n\n「設計」如何作為一種推測、如何作為一種思想實驗？本次講座的講者宮保睿，試著帶領你從推測設計的發源起點、思維方式、現在狀況、可能未來、創作與教學實踐來解析各種面向，試著讓我們透過推測設計思維去思考著當面對未知未來時，「這個世界可能會變成什麼樣子？」這個重要的提問。",
          "locationName": "1102",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ae14e984-b8a3-4c44-abd9-1ea32ee37583",
          "title": "春池循環設計的各種實踐與未來",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "在氣候變遷與溫室效應影響著我們的生活，循環經濟與循環設計變成一個重要未來課題。 「我們過去的需求都是消耗，但我們想塑造的未來是，把未來的需求都成為新的創造。」春池玻璃未來將繼續以循環玻璃為載體，希望影響更多產業走向循環經濟。\n\n春池玻璃，目前跨足於工業原料、科技建材、文化藝術與觀光工廠。本業為專業回收玻璃與再處理之企業，總公司在台灣新竹，並擁有三家相關企業。目前每年回收並處理超過 10 萬噸的春池玻璃，目前為全台最具規模之廢棄玻璃回收業者。其企業理念為永續經營，綠色創新。在 2015 更獲得根留台灣，展望全球之「金根獎」之殊榮。蔡總統英文更在 2016 年 9 月親自參訪春池玻璃觀光工廠，並給予極高評價，稱春池玻璃為台灣「循環經濟」之典範。更在 2017 年獲得 British Chamber of Commerce 之 Better Business Award 社會企業首獎。更在 2018 年獲得總統創新獎與艾森豪獎金學人殊榮",
          "locationName": "1103",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        }
      ]
    },
    {
      "date": "2021-10-07",
      "sessions": [
        {
          "uuid": "08724314-8b0d-4b8b-bc97-aaf5870b4725",
          "title": "07年會開幕",
          "startTime": "09:30",
          "endTime": "09:45",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "開幕式",
          "description": "開幕式",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [
            {
              "uuid": "F2110Wv8",
              "categoryTitle": "課程檔案",
              "title": "課程檔案",
              "description": null,
              "size": "Bytes",
              "publishUp": null,
              "downloadLink": "http://zerone.test/api/file/download/F2110Wv8",
              "contentType": "application/pdf"
            }
          ],
          "link": null
        },
        {
          "uuid": "6f0fbac6-ea7d-4c9d-b46d-5f8840c1d826",
          "title": "Making Digital Tangible: The Battle Against the Pixel Empire",
          "startTime": "09:45",
          "endTime": "10:55",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 1,
          "linkOpeningTime": null,
          "introtext": "數位資訊實體化：一場與像素帝國抗衡的戰役",
          "description": "時下人機互動的主流研究大多關注實用層面－使用者需求、實際的應用系統，與易用性評估。Tangible Bits 和 Radical Atoms 則是願景驅動的研究，並以藝術取向執行。現今社會一項技術可能一年後就過時了，一個應用系統可能十年後就遭取代。但我們相信，一個真正的願景，能持續發揮影響超過百年。\n\nTangible Bits 的研究目的是實現打造人、數位資訊，與實體環境之間無接縫的介面（Seamless Interfaces），為數位資訊與運算提供實體介面，讓人們可以直接操控位元（bits），也能感知其存在，無論是在前景或背景意識之下（foreground and background of our consciousness）。我們的目標是發明新的設計媒介，不但能適用於科學分析，也應用在藝術表達。Tangible Bits 的研究理念除了利用即時感知與數位回饋帶來的運算呈現外，也充分利用人類豐富的感官能力，與人們ㄧ生與實體世界互動的多樣技能。",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "91312205-2007-4800-82fe-625f520c2ff0",
          "title": "休息交流時間",
          "startTime": "10:50",
          "endTime": "11:10",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "",
          "locationName": "11樓休息區",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "6bffa1c5-a89f-4468-a386-c7b448d6b2c6",
          "title": "漸進式的改革與創新 - 後疫情時代的設計體驗轉型",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "產品會隨著人們的生活一起演進，歷史悠久的產品，會發展出深根蒂固的使用習慣，企業內部也有完整的流程與堅實企業文化。然而，習慣與框架有時會成為設計師推進創新的門檻。 Lydia將透過幾個Yahoo奇摩在台灣與Verizon Media在歐洲線的產品開發實例，分享這幾年如何以體驗式設計帶領團隊走進使用者的生活，並且將同理心應用在同事和決策者身上，進而打破既有設計規範、跨國文化，讓體驗文化在組織中發酵，漸進式的改革並創造與時俱進的產品在不同市場中。\n\n我們都期待改革是快速與有效的，但很多時候使用者多年的使用體驗已經定型，Lydia 帶領的 Verizon Media 設計團隊從前期策略規劃、使用者體驗訪談到設計開發與上線後監測優化都有一套完整流程，並帶動合作部門推進創新維度與執行。本次將分享在改革的腳步中，如何加快企業內部的接受度、開發與溝通的速度，並透過設計管理，讓這樣的成功案例可以跨國推進、建立 SOP ; 更重要的是，聚沙成塔，如何有規劃與節奏的讓使用者漸進式轉移，擁抱新的體驗設計，並因應不同市場的快速變化，Lydia也將分享幾個後疫情時代，產品快速調整的實際案例。",
          "locationName": "1101",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ebe86034-7fda-464b-bebe-081f35d9703a",
          "title": "設計作為一種推測與思想實驗",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            },
            {
              "name": "王小明2",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "「我們的現實世界被無垠的可能世界所包圍。」\n\nLubomír Doležel, Heterocosmica: Fiction and Possible Worlds, 1999\n2005年從英國皇家藝術學院（Royal College of Art）設計互動系（Design Interactions）開始慢慢萌芽的推測設計（Speculative Design）思維，經過十幾年之後，近年來在西方世界的設計、藝術文化領域，引起了廣大的影響與辯論，而很多專家也認為推測設計是「推測未來」的重要方法之一，而在東方世界，這股氛圍也緩緩升起中。\n\n「設計」如何作為一種推測、如何作為一種思想實驗？本次講座的講者宮保睿，試著帶領你從推測設計的發源起點、思維方式、現在狀況、可能未來、創作與教學實踐來解析各種面向，試著讓我們透過推測設計思維去思考著當面對未知未來時，「這個世界可能會變成什麼樣子？」這個重要的提問。",
          "locationName": "1102",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ae14e984-b8a3-4c44-abd9-1ea32ee37583",
          "title": "春池循環設計的各種實踐與未來",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "在氣候變遷與溫室效應影響著我們的生活，循環經濟與循環設計變成一個重要未來課題。 「我們過去的需求都是消耗，但我們想塑造的未來是，把未來的需求都成為新的創造。」春池玻璃未來將繼續以循環玻璃為載體，希望影響更多產業走向循環經濟。\n\n春池玻璃，目前跨足於工業原料、科技建材、文化藝術與觀光工廠。本業為專業回收玻璃與再處理之企業，總公司在台灣新竹，並擁有三家相關企業。目前每年回收並處理超過 10 萬噸的春池玻璃，目前為全台最具規模之廢棄玻璃回收業者。其企業理念為永續經營，綠色創新。在 2015 更獲得根留台灣，展望全球之「金根獎」之殊榮。蔡總統英文更在 2016 年 9 月親自參訪春池玻璃觀光工廠，並給予極高評價，稱春池玻璃為台灣「循環經濟」之典範。更在 2017 年獲得 British Chamber of Commerce 之 Better Business Award 社會企業首獎。更在 2018 年獲得總統創新獎與艾森豪獎金學人殊榮",
          "locationName": "1103",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        }
      ]
    },
    {
      "date": "2021-10-08",
      "sessions": [
        {
          "uuid": "08724314-8b0d-4b8b-bc97-aaf5870b4725",
          "title": "08年會開幕",
          "startTime": "09:30",
          "endTime": "09:45",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "開幕式",
          "description": "開幕式",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [
            {
              "uuid": "F2110Wv8",
              "categoryTitle": "課程檔案",
              "title": "課程檔案",
              "description": null,
              "size": "Bytes",
              "publishUp": null,
              "downloadLink": "http://zerone.test/api/file/download/F2110Wv8",
              "contentType": "application/pdf"
            }
          ],
          "link": null
        },
        {
          "uuid": "6f0fbac6-ea7d-4c9d-b46d-5f8840c1d826",
          "title": "Making Digital Tangible: The Battle Against the Pixel Empire",
          "startTime": "09:45",
          "endTime": "10:55",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 1,
          "linkOpeningTime": null,
          "introtext": "數位資訊實體化：一場與像素帝國抗衡的戰役",
          "description": "時下人機互動的主流研究大多關注實用層面－使用者需求、實際的應用系統，與易用性評估。Tangible Bits 和 Radical Atoms 則是願景驅動的研究，並以藝術取向執行。現今社會一項技術可能一年後就過時了，一個應用系統可能十年後就遭取代。但我們相信，一個真正的願景，能持續發揮影響超過百年。\n\nTangible Bits 的研究目的是實現打造人、數位資訊，與實體環境之間無接縫的介面（Seamless Interfaces），為數位資訊與運算提供實體介面，讓人們可以直接操控位元（bits），也能感知其存在，無論是在前景或背景意識之下（foreground and background of our consciousness）。我們的目標是發明新的設計媒介，不但能適用於科學分析，也應用在藝術表達。Tangible Bits 的研究理念除了利用即時感知與數位回饋帶來的運算呈現外，也充分利用人類豐富的感官能力，與人們ㄧ生與實體世界互動的多樣技能。",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "91312205-2007-4800-82fe-625f520c2ff0",
          "title": "休息交流時間",
          "startTime": "10:50",
          "endTime": "11:10",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "",
          "locationName": "11樓休息區",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "6bffa1c5-a89f-4468-a386-c7b448d6b2c6",
          "title": "漸進式的改革與創新 - 後疫情時代的設計體驗轉型",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "產品會隨著人們的生活一起演進，歷史悠久的產品，會發展出深根蒂固的使用習慣，企業內部也有完整的流程與堅實企業文化。然而，習慣與框架有時會成為設計師推進創新的門檻。 Lydia將透過幾個Yahoo奇摩在台灣與Verizon Media在歐洲線的產品開發實例，分享這幾年如何以體驗式設計帶領團隊走進使用者的生活，並且將同理心應用在同事和決策者身上，進而打破既有設計規範、跨國文化，讓體驗文化在組織中發酵，漸進式的改革並創造與時俱進的產品在不同市場中。\n\n我們都期待改革是快速與有效的，但很多時候使用者多年的使用體驗已經定型，Lydia 帶領的 Verizon Media 設計團隊從前期策略規劃、使用者體驗訪談到設計開發與上線後監測優化都有一套完整流程，並帶動合作部門推進創新維度與執行。本次將分享在改革的腳步中，如何加快企業內部的接受度、開發與溝通的速度，並透過設計管理，讓這樣的成功案例可以跨國推進、建立 SOP ; 更重要的是，聚沙成塔，如何有規劃與節奏的讓使用者漸進式轉移，擁抱新的體驗設計，並因應不同市場的快速變化，Lydia也將分享幾個後疫情時代，產品快速調整的實際案例。",
          "locationName": "1101",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ebe86034-7fda-464b-bebe-081f35d9703a",
          "title": "設計作為一種推測與思想實驗",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            },
            {
              "name": "王小明2",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "「我們的現實世界被無垠的可能世界所包圍。」\n\nLubomír Doležel, Heterocosmica: Fiction and Possible Worlds, 1999\n2005年從英國皇家藝術學院（Royal College of Art）設計互動系（Design Interactions）開始慢慢萌芽的推測設計（Speculative Design）思維，經過十幾年之後，近年來在西方世界的設計、藝術文化領域，引起了廣大的影響與辯論，而很多專家也認為推測設計是「推測未來」的重要方法之一，而在東方世界，這股氛圍也緩緩升起中。\n\n「設計」如何作為一種推測、如何作為一種思想實驗？本次講座的講者宮保睿，試著帶領你從推測設計的發源起點、思維方式、現在狀況、可能未來、創作與教學實踐來解析各種面向，試著讓我們透過推測設計思維去思考著當面對未知未來時，「這個世界可能會變成什麼樣子？」這個重要的提問。",
          "locationName": "1102",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ae14e984-b8a3-4c44-abd9-1ea32ee37583",
          "title": "春池循環設計的各種實踐與未來",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "在氣候變遷與溫室效應影響著我們的生活，循環經濟與循環設計變成一個重要未來課題。 「我們過去的需求都是消耗，但我們想塑造的未來是，把未來的需求都成為新的創造。」春池玻璃未來將繼續以循環玻璃為載體，希望影響更多產業走向循環經濟。\n\n春池玻璃，目前跨足於工業原料、科技建材、文化藝術與觀光工廠。本業為專業回收玻璃與再處理之企業，總公司在台灣新竹，並擁有三家相關企業。目前每年回收並處理超過 10 萬噸的春池玻璃，目前為全台最具規模之廢棄玻璃回收業者。其企業理念為永續經營，綠色創新。在 2015 更獲得根留台灣，展望全球之「金根獎」之殊榮。蔡總統英文更在 2016 年 9 月親自參訪春池玻璃觀光工廠，並給予極高評價，稱春池玻璃為台灣「循環經濟」之典範。更在 2017 年獲得 British Chamber of Commerce 之 Better Business Award 社會企業首獎。更在 2018 年獲得總統創新獎與艾森豪獎金學人殊榮",
          "locationName": "1103",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        }
      ]
    },
  ]
};

// 線上 多天 分場次報名
export const FAKE_EVENT_ITEM_ONLINE_MULTIPLE_PARTIAL = {
  "title": "IxDTW 互動設計年會 2021（實體多天多場）",
  "alias": "alias",
  "seriesNum": "seriesNum",
  "state": 1,
  "type": "online", // 實體
  "dateType": "multiple", // 多天
  "chargeType": "impartial",
  "dateTimeRange": "2021/10/03(六) (08:00~22:00)",
  "registrationType": "partial", // 多場
  "registrationStartDate": "2021-08-26 07:59:59",
  "registrationEndDate": "2022-10-02 23:59:59",
  "inProgress": 0,
  "hasAbsentLimit": 0,
  "absentLimit": 1,
  "canApply": 0,
  "basePrice": 0,
  "salePrice": 0,
  "link": "https://youtu.be/acefhx",
  "bannerImage": "banner.png",
  "slideshow": [
    {
      "path": "slideshow1.png",
      "default": 1
    },
    {
      "path": "slideshow2.png",
      "default": 0
    }
  ],
  "introtext": "設計下一個十年 - 多元與躍進",
  "description": "IxDTW 互動設計年會是 2021 年台灣主要的互動設計與使用者體驗設計的論壇。將於台北舉行，我們即將邀請 25 ~30 位來自國內外產官學界的設計專家及知名講者，分享他們的思維與經驗，以及在設計產品中所遇到的挑戰，讓會眾拓展跨職能的視野。\n\n今年，以「多元與躍進」作為大會主軸，帶領會眾共同思考下一個十年會朝那些趨勢前進，而多元文化是如何影響我們的生活及設計方式，形成新的意義。先行者們，持續躍進及挑戰的過程，將有助我們理解產業的變動，設計師將其價值轉化為設計行動，結合在地優勢面向全世界。",
  "locationName": "張榮發國際會議中心",
  "city": "臺北市",
  "district": "中正區",
  "address": "中山南路11號11樓",
  "zipcode": "101",
  "lat": 25.1234567,
  "lng": 121.02564,
  "canRegisterGroup": 7,
  "requireCoupon": 1,
  "phoneCode": "02",
  "phone": "25316628",
  "needReview": 1,
  "params": [],
  "meals": [
    {
      "id": 3,
      "date": "2021-10-03",
      "options": [
        "葷食餐點",
        "素食餐點"
      ],
      "params": []
    },
    {
      "id": 4,
      "date": "2021-10-04",
      "options": [
        "炙燒北海道干貝丼",
        "炙燒北海道干貝丼",
        "馬糞海膽散壽司"
      ],
      "params": []
    },
    {
      "id": 5,
      "date": "2021-10-05",
      "options": [
        "炙燒北海道干貝丼",
        "炙燒北海道干貝丼",
        "馬糞海膽散壽司"
      ],
      "params": []
    },
    {
      "id": 6,
      "date": "2021-10-06",
      "options": [
        "炙燒北海道干貝丼",
        "炙燒北海道干貝丼",
        "馬糞海膽散壽司"
      ],
      "params": []
    },
    {
      "id": 7,
      "date": "2021-10-07",
      "options": [
        "炙燒北海道干貝丼",
        "炙燒北海道干貝丼",
        "馬糞海膽散壽司"
      ],
      "params": []
    },
    {
      "id": 8,
      "date": "2021-10-08",
      "options": [
        "炙燒北海道干貝丼",
        "炙燒北海道干貝丼",
        "馬糞海膽散壽司"
      ],
      "params": []
    }
  ],
  "questions": [
    {
      "title": "感興趣的議題",
      "state": 1,
      "type": "select",
      "value": "",
      "required": 1,
      "description": "請選擇感興趣的議題",
      "params": {
        "options": [
          "資訊安全",
          "虛擬化",
          "AI大數據"
        ]
      }
    }
  ],
  "files": [
    {
      "uuid": "F2110Wv8",
      "categoryTitle": "課程檔案",
      "title": "課程檔案",
      "description": null,
      "size": "Bytes",
      "publishUp": null,
      "downloadLink": "http://zerone.test/api/file/download/F2110Wv8"
    },
    {
      "uuid": "F2110Wv8",
      "categoryTitle": "課程檔案",
      "title": "課程檔案",
      "description": null,
      "size": "Bytes",
      "publishUp": null,
      "downloadLink": "http://zerone.test/api/file/download/F2110Wv8"
    }
  ],
  "sponsors": [
    {
      "title": "Microsoft",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://microsoft.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    }
  ],
  "brands": [
    {
      "title": "BlcakBerry",
      "alias": "blcakberry",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "contact": [
        {
          "name": "王小明",
          "gender": "先生",
          "countryCode": "02",
          "phone": "22221234",
          "extension": "1111"
        },
        {
          "name": "林小花",
          "gender": "先生",
          "countryCode": "02",
          "phone": "22225566",
          "extension": "2222"
        }
      ]
    },
  ],
  "sessions": [
    {
      "date": "2021-10-21",
      "sessions": [
        {
          "uuid": "08724314-8b0d-4b8b-bc97-aaf5870b4725",
          "title": "年會開幕",
          "startTime": "09:30",
          "endTime": "09:45",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "開幕式",
          "description": "開幕式",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [
            {
              "uuid": "F2110Wv8",
              "categoryTitle": "課程檔案",
              "title": "課程檔案",
              "description": null,
              "size": "Bytes",
              "publishUp": null,
              "downloadLink": "http://zerone.test/api/file/download/F2110Wv8",
              "contentType": "application/pdf"
            }
          ],
          "link": null
        },
        {
          "uuid": "6f0fbac6-ea7d-4c9d-b46d-5f8840c1d826",
          "title": "Making Digital Tangible: The Battle Against the Pixel Empire",
          "startTime": "15:00",
          "endTime": "16:00",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 1,
          "linkOpeningTime": null,
          "introtext": "數位資訊實體化：一場與像素帝國抗衡的戰役",
          "description": "時下人機互動的主流研究大多關注實用層面－使用者需求、實際的應用系統，與易用性評估。Tangible Bits 和 Radical Atoms 則是願景驅動的研究，並以藝術取向執行。現今社會一項技術可能一年後就過時了，一個應用系統可能十年後就遭取代。但我們相信，一個真正的願景，能持續發揮影響超過百年。\n\nTangible Bits 的研究目的是實現打造人、數位資訊，與實體環境之間無接縫的介面（Seamless Interfaces），為數位資訊與運算提供實體介面，讓人們可以直接操控位元（bits），也能感知其存在，無論是在前景或背景意識之下（foreground and background of our consciousness）。我們的目標是發明新的設計媒介，不但能適用於科學分析，也應用在藝術表達。Tangible Bits 的研究理念除了利用即時感知與數位回饋帶來的運算呈現外，也充分利用人類豐富的感官能力，與人們ㄧ生與實體世界互動的多樣技能。",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "91312205-2007-4800-82fe-625f520c2ff0",
          "title": "休息交流時間",
          "startTime": "10:50",
          "endTime": "11:10",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "",
          "locationName": "11樓休息區",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "6bffa1c5-a89f-4468-a386-c7b448d6b2c6",
          "title": "漸進式的改革與創新 - 後疫情時代的設計體驗轉型",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "產品會隨著人們的生活一起演進，歷史悠久的產品，會發展出深根蒂固的使用習慣，企業內部也有完整的流程與堅實企業文化。然而，習慣與框架有時會成為設計師推進創新的門檻。 Lydia將透過幾個Yahoo奇摩在台灣與Verizon Media在歐洲線的產品開發實例，分享這幾年如何以體驗式設計帶領團隊走進使用者的生活，並且將同理心應用在同事和決策者身上，進而打破既有設計規範、跨國文化，讓體驗文化在組織中發酵，漸進式的改革並創造與時俱進的產品在不同市場中。\n\n我們都期待改革是快速與有效的，但很多時候使用者多年的使用體驗已經定型，Lydia 帶領的 Verizon Media 設計團隊從前期策略規劃、使用者體驗訪談到設計開發與上線後監測優化都有一套完整流程，並帶動合作部門推進創新維度與執行。本次將分享在改革的腳步中，如何加快企業內部的接受度、開發與溝通的速度，並透過設計管理，讓這樣的成功案例可以跨國推進、建立 SOP ; 更重要的是，聚沙成塔，如何有規劃與節奏的讓使用者漸進式轉移，擁抱新的體驗設計，並因應不同市場的快速變化，Lydia也將分享幾個後疫情時代，產品快速調整的實際案例。",
          "locationName": "1101",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ebe86034-7fda-464b-bebe-081f35d9703a",
          "title": "設計作為一種推測與思想實驗",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            },
            {
              "name": "王小明2",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "「我們的現實世界被無垠的可能世界所包圍。」\n\nLubomír Doležel, Heterocosmica: Fiction and Possible Worlds, 1999\n2005年從英國皇家藝術學院（Royal College of Art）設計互動系（Design Interactions）開始慢慢萌芽的推測設計（Speculative Design）思維，經過十幾年之後，近年來在西方世界的設計、藝術文化領域，引起了廣大的影響與辯論，而很多專家也認為推測設計是「推測未來」的重要方法之一，而在東方世界，這股氛圍也緩緩升起中。\n\n「設計」如何作為一種推測、如何作為一種思想實驗？本次講座的講者宮保睿，試著帶領你從推測設計的發源起點、思維方式、現在狀況、可能未來、創作與教學實踐來解析各種面向，試著讓我們透過推測設計思維去思考著當面對未知未來時，「這個世界可能會變成什麼樣子？」這個重要的提問。",
          "locationName": "1102",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ae14e984-b8a3-4c44-abd9-1ea32ee37583",
          "title": "春池循環設計的各種實踐與未來",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "在氣候變遷與溫室效應影響著我們的生活，循環經濟與循環設計變成一個重要未來課題。 「我們過去的需求都是消耗，但我們想塑造的未來是，把未來的需求都成為新的創造。」春池玻璃未來將繼續以循環玻璃為載體，希望影響更多產業走向循環經濟。\n\n春池玻璃，目前跨足於工業原料、科技建材、文化藝術與觀光工廠。本業為專業回收玻璃與再處理之企業，總公司在台灣新竹，並擁有三家相關企業。目前每年回收並處理超過 10 萬噸的春池玻璃，目前為全台最具規模之廢棄玻璃回收業者。其企業理念為永續經營，綠色創新。在 2015 更獲得根留台灣，展望全球之「金根獎」之殊榮。蔡總統英文更在 2016 年 9 月親自參訪春池玻璃觀光工廠，並給予極高評價，稱春池玻璃為台灣「循環經濟」之典範。更在 2017 年獲得 British Chamber of Commerce 之 Better Business Award 社會企業首獎。更在 2018 年獲得總統創新獎與艾森豪獎金學人殊榮",
          "locationName": "1103",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        }
      ]
    },
    {
      "date": "2021-10-04",
      "sessions": [
        {
          "uuid": "08724314-8b0d-4b8b-bc97-aaf5870b4725",
          "title": "04年會開幕",
          "startTime": "09:30",
          "endTime": "09:45",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "開幕式",
          "description": "開幕式",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [
            {
              "uuid": "F2110Wv8",
              "categoryTitle": "課程檔案",
              "title": "課程檔案",
              "description": null,
              "size": "Bytes",
              "publishUp": null,
              "downloadLink": "http://zerone.test/api/file/download/F2110Wv8",
              "contentType": "application/pdf"
            }
          ],
          "link": null
        },
        {
          "uuid": "6f0fbac6-ea7d-4c9d-b46d-5f8840c1d826",
          "title": "Making Digital Tangible: The Battle Against the Pixel Empire",
          "startTime": "09:45",
          "endTime": "10:55",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 1,
          "linkOpeningTime": null,
          "introtext": "數位資訊實體化：一場與像素帝國抗衡的戰役",
          "description": "時下人機互動的主流研究大多關注實用層面－使用者需求、實際的應用系統，與易用性評估。Tangible Bits 和 Radical Atoms 則是願景驅動的研究，並以藝術取向執行。現今社會一項技術可能一年後就過時了，一個應用系統可能十年後就遭取代。但我們相信，一個真正的願景，能持續發揮影響超過百年。\n\nTangible Bits 的研究目的是實現打造人、數位資訊，與實體環境之間無接縫的介面（Seamless Interfaces），為數位資訊與運算提供實體介面，讓人們可以直接操控位元（bits），也能感知其存在，無論是在前景或背景意識之下（foreground and background of our consciousness）。我們的目標是發明新的設計媒介，不但能適用於科學分析，也應用在藝術表達。Tangible Bits 的研究理念除了利用即時感知與數位回饋帶來的運算呈現外，也充分利用人類豐富的感官能力，與人們ㄧ生與實體世界互動的多樣技能。",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "91312205-2007-4800-82fe-625f520c2ff0",
          "title": "休息交流時間",
          "startTime": "10:50",
          "endTime": "11:10",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "",
          "locationName": "11樓休息區",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "6bffa1c5-a89f-4468-a386-c7b448d6b2c6",
          "title": "漸進式的改革與創新 - 後疫情時代的設計體驗轉型",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "產品會隨著人們的生活一起演進，歷史悠久的產品，會發展出深根蒂固的使用習慣，企業內部也有完整的流程與堅實企業文化。然而，習慣與框架有時會成為設計師推進創新的門檻。 Lydia將透過幾個Yahoo奇摩在台灣與Verizon Media在歐洲線的產品開發實例，分享這幾年如何以體驗式設計帶領團隊走進使用者的生活，並且將同理心應用在同事和決策者身上，進而打破既有設計規範、跨國文化，讓體驗文化在組織中發酵，漸進式的改革並創造與時俱進的產品在不同市場中。\n\n我們都期待改革是快速與有效的，但很多時候使用者多年的使用體驗已經定型，Lydia 帶領的 Verizon Media 設計團隊從前期策略規劃、使用者體驗訪談到設計開發與上線後監測優化都有一套完整流程，並帶動合作部門推進創新維度與執行。本次將分享在改革的腳步中，如何加快企業內部的接受度、開發與溝通的速度，並透過設計管理，讓這樣的成功案例可以跨國推進、建立 SOP ; 更重要的是，聚沙成塔，如何有規劃與節奏的讓使用者漸進式轉移，擁抱新的體驗設計，並因應不同市場的快速變化，Lydia也將分享幾個後疫情時代，產品快速調整的實際案例。",
          "locationName": "1101",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ebe86034-7fda-464b-bebe-081f35d9703a",
          "title": "設計作為一種推測與思想實驗",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            },
            {
              "name": "王小明2",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "「我們的現實世界被無垠的可能世界所包圍。」\n\nLubomír Doležel, Heterocosmica: Fiction and Possible Worlds, 1999\n2005年從英國皇家藝術學院（Royal College of Art）設計互動系（Design Interactions）開始慢慢萌芽的推測設計（Speculative Design）思維，經過十幾年之後，近年來在西方世界的設計、藝術文化領域，引起了廣大的影響與辯論，而很多專家也認為推測設計是「推測未來」的重要方法之一，而在東方世界，這股氛圍也緩緩升起中。\n\n「設計」如何作為一種推測、如何作為一種思想實驗？本次講座的講者宮保睿，試著帶領你從推測設計的發源起點、思維方式、現在狀況、可能未來、創作與教學實踐來解析各種面向，試著讓我們透過推測設計思維去思考著當面對未知未來時，「這個世界可能會變成什麼樣子？」這個重要的提問。",
          "locationName": "1102",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ae14e984-b8a3-4c44-abd9-1ea32ee37583",
          "title": "春池循環設計的各種實踐與未來",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "在氣候變遷與溫室效應影響著我們的生活，循環經濟與循環設計變成一個重要未來課題。 「我們過去的需求都是消耗，但我們想塑造的未來是，把未來的需求都成為新的創造。」春池玻璃未來將繼續以循環玻璃為載體，希望影響更多產業走向循環經濟。\n\n春池玻璃，目前跨足於工業原料、科技建材、文化藝術與觀光工廠。本業為專業回收玻璃與再處理之企業，總公司在台灣新竹，並擁有三家相關企業。目前每年回收並處理超過 10 萬噸的春池玻璃，目前為全台最具規模之廢棄玻璃回收業者。其企業理念為永續經營，綠色創新。在 2015 更獲得根留台灣，展望全球之「金根獎」之殊榮。蔡總統英文更在 2016 年 9 月親自參訪春池玻璃觀光工廠，並給予極高評價，稱春池玻璃為台灣「循環經濟」之典範。更在 2017 年獲得 British Chamber of Commerce 之 Better Business Award 社會企業首獎。更在 2018 年獲得總統創新獎與艾森豪獎金學人殊榮",
          "locationName": "1103",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        }
      ]
    },
    {
      "date": "2021-10-05",
      "sessions": [
        {
          "uuid": "08724314-8b0d-4b8b-bc97-aaf5870b4725",
          "title": "05年會開幕",
          "startTime": "09:30",
          "endTime": "09:45",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "開幕式",
          "description": "開幕式",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [
            {
              "uuid": "F2110Wv8",
              "categoryTitle": "課程檔案",
              "title": "課程檔案",
              "description": null,
              "size": "Bytes",
              "publishUp": null,
              "downloadLink": "http://zerone.test/api/file/download/F2110Wv8",
              "contentType": "application/pdf"
            }
          ],
          "link": null
        },
        {
          "uuid": "6f0fbac6-ea7d-4c9d-b46d-5f8840c1d826",
          "title": "Making Digital Tangible: The Battle Against the Pixel Empire",
          "startTime": "09:45",
          "endTime": "10:55",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 1,
          "linkOpeningTime": null,
          "introtext": "數位資訊實體化：一場與像素帝國抗衡的戰役",
          "description": "時下人機互動的主流研究大多關注實用層面－使用者需求、實際的應用系統，與易用性評估。Tangible Bits 和 Radical Atoms 則是願景驅動的研究，並以藝術取向執行。現今社會一項技術可能一年後就過時了，一個應用系統可能十年後就遭取代。但我們相信，一個真正的願景，能持續發揮影響超過百年。\n\nTangible Bits 的研究目的是實現打造人、數位資訊，與實體環境之間無接縫的介面（Seamless Interfaces），為數位資訊與運算提供實體介面，讓人們可以直接操控位元（bits），也能感知其存在，無論是在前景或背景意識之下（foreground and background of our consciousness）。我們的目標是發明新的設計媒介，不但能適用於科學分析，也應用在藝術表達。Tangible Bits 的研究理念除了利用即時感知與數位回饋帶來的運算呈現外，也充分利用人類豐富的感官能力，與人們ㄧ生與實體世界互動的多樣技能。",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "91312205-2007-4800-82fe-625f520c2ff0",
          "title": "休息交流時間",
          "startTime": "10:50",
          "endTime": "11:10",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "",
          "locationName": "11樓休息區",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "6bffa1c5-a89f-4468-a386-c7b448d6b2c6",
          "title": "漸進式的改革與創新 - 後疫情時代的設計體驗轉型",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "產品會隨著人們的生活一起演進，歷史悠久的產品，會發展出深根蒂固的使用習慣，企業內部也有完整的流程與堅實企業文化。然而，習慣與框架有時會成為設計師推進創新的門檻。 Lydia將透過幾個Yahoo奇摩在台灣與Verizon Media在歐洲線的產品開發實例，分享這幾年如何以體驗式設計帶領團隊走進使用者的生活，並且將同理心應用在同事和決策者身上，進而打破既有設計規範、跨國文化，讓體驗文化在組織中發酵，漸進式的改革並創造與時俱進的產品在不同市場中。\n\n我們都期待改革是快速與有效的，但很多時候使用者多年的使用體驗已經定型，Lydia 帶領的 Verizon Media 設計團隊從前期策略規劃、使用者體驗訪談到設計開發與上線後監測優化都有一套完整流程，並帶動合作部門推進創新維度與執行。本次將分享在改革的腳步中，如何加快企業內部的接受度、開發與溝通的速度，並透過設計管理，讓這樣的成功案例可以跨國推進、建立 SOP ; 更重要的是，聚沙成塔，如何有規劃與節奏的讓使用者漸進式轉移，擁抱新的體驗設計，並因應不同市場的快速變化，Lydia也將分享幾個後疫情時代，產品快速調整的實際案例。",
          "locationName": "1101",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ebe86034-7fda-464b-bebe-081f35d9703a",
          "title": "設計作為一種推測與思想實驗",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            },
            {
              "name": "王小明2",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "「我們的現實世界被無垠的可能世界所包圍。」\n\nLubomír Doležel, Heterocosmica: Fiction and Possible Worlds, 1999\n2005年從英國皇家藝術學院（Royal College of Art）設計互動系（Design Interactions）開始慢慢萌芽的推測設計（Speculative Design）思維，經過十幾年之後，近年來在西方世界的設計、藝術文化領域，引起了廣大的影響與辯論，而很多專家也認為推測設計是「推測未來」的重要方法之一，而在東方世界，這股氛圍也緩緩升起中。\n\n「設計」如何作為一種推測、如何作為一種思想實驗？本次講座的講者宮保睿，試著帶領你從推測設計的發源起點、思維方式、現在狀況、可能未來、創作與教學實踐來解析各種面向，試著讓我們透過推測設計思維去思考著當面對未知未來時，「這個世界可能會變成什麼樣子？」這個重要的提問。",
          "locationName": "1102",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ae14e984-b8a3-4c44-abd9-1ea32ee37583",
          "title": "春池循環設計的各種實踐與未來",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "在氣候變遷與溫室效應影響著我們的生活，循環經濟與循環設計變成一個重要未來課題。 「我們過去的需求都是消耗，但我們想塑造的未來是，把未來的需求都成為新的創造。」春池玻璃未來將繼續以循環玻璃為載體，希望影響更多產業走向循環經濟。\n\n春池玻璃，目前跨足於工業原料、科技建材、文化藝術與觀光工廠。本業為專業回收玻璃與再處理之企業，總公司在台灣新竹，並擁有三家相關企業。目前每年回收並處理超過 10 萬噸的春池玻璃，目前為全台最具規模之廢棄玻璃回收業者。其企業理念為永續經營，綠色創新。在 2015 更獲得根留台灣，展望全球之「金根獎」之殊榮。蔡總統英文更在 2016 年 9 月親自參訪春池玻璃觀光工廠，並給予極高評價，稱春池玻璃為台灣「循環經濟」之典範。更在 2017 年獲得 British Chamber of Commerce 之 Better Business Award 社會企業首獎。更在 2018 年獲得總統創新獎與艾森豪獎金學人殊榮",
          "locationName": "1103",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        }
      ]
    },
    {
      "date": "2021-10-06",
      "sessions": [
        {
          "uuid": "08724314-8b0d-4b8b-bc97-aaf5870b4725",
          "title": "06年會開幕",
          "startTime": "09:30",
          "endTime": "09:45",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "開幕式",
          "description": "開幕式",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [
            {
              "uuid": "F2110Wv8",
              "categoryTitle": "課程檔案",
              "title": "課程檔案",
              "description": null,
              "size": "Bytes",
              "publishUp": null,
              "downloadLink": "http://zerone.test/api/file/download/F2110Wv8",
              "contentType": "application/pdf"
            }
          ],
          "link": null
        },
        {
          "uuid": "6f0fbac6-ea7d-4c9d-b46d-5f8840c1d826",
          "title": "Making Digital Tangible: The Battle Against the Pixel Empire",
          "startTime": "09:45",
          "endTime": "10:55",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 1,
          "linkOpeningTime": null,
          "introtext": "數位資訊實體化：一場與像素帝國抗衡的戰役",
          "description": "時下人機互動的主流研究大多關注實用層面－使用者需求、實際的應用系統，與易用性評估。Tangible Bits 和 Radical Atoms 則是願景驅動的研究，並以藝術取向執行。現今社會一項技術可能一年後就過時了，一個應用系統可能十年後就遭取代。但我們相信，一個真正的願景，能持續發揮影響超過百年。\n\nTangible Bits 的研究目的是實現打造人、數位資訊，與實體環境之間無接縫的介面（Seamless Interfaces），為數位資訊與運算提供實體介面，讓人們可以直接操控位元（bits），也能感知其存在，無論是在前景或背景意識之下（foreground and background of our consciousness）。我們的目標是發明新的設計媒介，不但能適用於科學分析，也應用在藝術表達。Tangible Bits 的研究理念除了利用即時感知與數位回饋帶來的運算呈現外，也充分利用人類豐富的感官能力，與人們ㄧ生與實體世界互動的多樣技能。",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "91312205-2007-4800-82fe-625f520c2ff0",
          "title": "休息交流時間",
          "startTime": "10:50",
          "endTime": "11:10",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "",
          "locationName": "11樓休息區",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "6bffa1c5-a89f-4468-a386-c7b448d6b2c6",
          "title": "漸進式的改革與創新 - 後疫情時代的設計體驗轉型",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "產品會隨著人們的生活一起演進，歷史悠久的產品，會發展出深根蒂固的使用習慣，企業內部也有完整的流程與堅實企業文化。然而，習慣與框架有時會成為設計師推進創新的門檻。 Lydia將透過幾個Yahoo奇摩在台灣與Verizon Media在歐洲線的產品開發實例，分享這幾年如何以體驗式設計帶領團隊走進使用者的生活，並且將同理心應用在同事和決策者身上，進而打破既有設計規範、跨國文化，讓體驗文化在組織中發酵，漸進式的改革並創造與時俱進的產品在不同市場中。\n\n我們都期待改革是快速與有效的，但很多時候使用者多年的使用體驗已經定型，Lydia 帶領的 Verizon Media 設計團隊從前期策略規劃、使用者體驗訪談到設計開發與上線後監測優化都有一套完整流程，並帶動合作部門推進創新維度與執行。本次將分享在改革的腳步中，如何加快企業內部的接受度、開發與溝通的速度，並透過設計管理，讓這樣的成功案例可以跨國推進、建立 SOP ; 更重要的是，聚沙成塔，如何有規劃與節奏的讓使用者漸進式轉移，擁抱新的體驗設計，並因應不同市場的快速變化，Lydia也將分享幾個後疫情時代，產品快速調整的實際案例。",
          "locationName": "1101",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ebe86034-7fda-464b-bebe-081f35d9703a",
          "title": "設計作為一種推測與思想實驗",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            },
            {
              "name": "王小明2",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "「我們的現實世界被無垠的可能世界所包圍。」\n\nLubomír Doležel, Heterocosmica: Fiction and Possible Worlds, 1999\n2005年從英國皇家藝術學院（Royal College of Art）設計互動系（Design Interactions）開始慢慢萌芽的推測設計（Speculative Design）思維，經過十幾年之後，近年來在西方世界的設計、藝術文化領域，引起了廣大的影響與辯論，而很多專家也認為推測設計是「推測未來」的重要方法之一，而在東方世界，這股氛圍也緩緩升起中。\n\n「設計」如何作為一種推測、如何作為一種思想實驗？本次講座的講者宮保睿，試著帶領你從推測設計的發源起點、思維方式、現在狀況、可能未來、創作與教學實踐來解析各種面向，試著讓我們透過推測設計思維去思考著當面對未知未來時，「這個世界可能會變成什麼樣子？」這個重要的提問。",
          "locationName": "1102",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ae14e984-b8a3-4c44-abd9-1ea32ee37583",
          "title": "春池循環設計的各種實踐與未來",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "在氣候變遷與溫室效應影響著我們的生活，循環經濟與循環設計變成一個重要未來課題。 「我們過去的需求都是消耗，但我們想塑造的未來是，把未來的需求都成為新的創造。」春池玻璃未來將繼續以循環玻璃為載體，希望影響更多產業走向循環經濟。\n\n春池玻璃，目前跨足於工業原料、科技建材、文化藝術與觀光工廠。本業為專業回收玻璃與再處理之企業，總公司在台灣新竹，並擁有三家相關企業。目前每年回收並處理超過 10 萬噸的春池玻璃，目前為全台最具規模之廢棄玻璃回收業者。其企業理念為永續經營，綠色創新。在 2015 更獲得根留台灣，展望全球之「金根獎」之殊榮。蔡總統英文更在 2016 年 9 月親自參訪春池玻璃觀光工廠，並給予極高評價，稱春池玻璃為台灣「循環經濟」之典範。更在 2017 年獲得 British Chamber of Commerce 之 Better Business Award 社會企業首獎。更在 2018 年獲得總統創新獎與艾森豪獎金學人殊榮",
          "locationName": "1103",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        }
      ]
    },
    {
      "date": "2021-10-07",
      "sessions": [
        {
          "uuid": "08724314-8b0d-4b8b-bc97-aaf5870b4725",
          "title": "07年會開幕",
          "startTime": "09:30",
          "endTime": "09:45",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "開幕式",
          "description": "開幕式",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [
            {
              "uuid": "F2110Wv8",
              "categoryTitle": "課程檔案",
              "title": "課程檔案",
              "description": null,
              "size": "Bytes",
              "publishUp": null,
              "downloadLink": "http://zerone.test/api/file/download/F2110Wv8",
              "contentType": "application/pdf"
            }
          ],
          "link": null
        },
        {
          "uuid": "6f0fbac6-ea7d-4c9d-b46d-5f8840c1d826",
          "title": "Making Digital Tangible: The Battle Against the Pixel Empire",
          "startTime": "09:45",
          "endTime": "10:55",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 1,
          "linkOpeningTime": null,
          "introtext": "數位資訊實體化：一場與像素帝國抗衡的戰役",
          "description": "時下人機互動的主流研究大多關注實用層面－使用者需求、實際的應用系統，與易用性評估。Tangible Bits 和 Radical Atoms 則是願景驅動的研究，並以藝術取向執行。現今社會一項技術可能一年後就過時了，一個應用系統可能十年後就遭取代。但我們相信，一個真正的願景，能持續發揮影響超過百年。\n\nTangible Bits 的研究目的是實現打造人、數位資訊，與實體環境之間無接縫的介面（Seamless Interfaces），為數位資訊與運算提供實體介面，讓人們可以直接操控位元（bits），也能感知其存在，無論是在前景或背景意識之下（foreground and background of our consciousness）。我們的目標是發明新的設計媒介，不但能適用於科學分析，也應用在藝術表達。Tangible Bits 的研究理念除了利用即時感知與數位回饋帶來的運算呈現外，也充分利用人類豐富的感官能力，與人們ㄧ生與實體世界互動的多樣技能。",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "91312205-2007-4800-82fe-625f520c2ff0",
          "title": "休息交流時間",
          "startTime": "10:50",
          "endTime": "11:10",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "",
          "locationName": "11樓休息區",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "6bffa1c5-a89f-4468-a386-c7b448d6b2c6",
          "title": "漸進式的改革與創新 - 後疫情時代的設計體驗轉型",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "產品會隨著人們的生活一起演進，歷史悠久的產品，會發展出深根蒂固的使用習慣，企業內部也有完整的流程與堅實企業文化。然而，習慣與框架有時會成為設計師推進創新的門檻。 Lydia將透過幾個Yahoo奇摩在台灣與Verizon Media在歐洲線的產品開發實例，分享這幾年如何以體驗式設計帶領團隊走進使用者的生活，並且將同理心應用在同事和決策者身上，進而打破既有設計規範、跨國文化，讓體驗文化在組織中發酵，漸進式的改革並創造與時俱進的產品在不同市場中。\n\n我們都期待改革是快速與有效的，但很多時候使用者多年的使用體驗已經定型，Lydia 帶領的 Verizon Media 設計團隊從前期策略規劃、使用者體驗訪談到設計開發與上線後監測優化都有一套完整流程，並帶動合作部門推進創新維度與執行。本次將分享在改革的腳步中，如何加快企業內部的接受度、開發與溝通的速度，並透過設計管理，讓這樣的成功案例可以跨國推進、建立 SOP ; 更重要的是，聚沙成塔，如何有規劃與節奏的讓使用者漸進式轉移，擁抱新的體驗設計，並因應不同市場的快速變化，Lydia也將分享幾個後疫情時代，產品快速調整的實際案例。",
          "locationName": "1101",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ebe86034-7fda-464b-bebe-081f35d9703a",
          "title": "設計作為一種推測與思想實驗",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            },
            {
              "name": "王小明2",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "「我們的現實世界被無垠的可能世界所包圍。」\n\nLubomír Doležel, Heterocosmica: Fiction and Possible Worlds, 1999\n2005年從英國皇家藝術學院（Royal College of Art）設計互動系（Design Interactions）開始慢慢萌芽的推測設計（Speculative Design）思維，經過十幾年之後，近年來在西方世界的設計、藝術文化領域，引起了廣大的影響與辯論，而很多專家也認為推測設計是「推測未來」的重要方法之一，而在東方世界，這股氛圍也緩緩升起中。\n\n「設計」如何作為一種推測、如何作為一種思想實驗？本次講座的講者宮保睿，試著帶領你從推測設計的發源起點、思維方式、現在狀況、可能未來、創作與教學實踐來解析各種面向，試著讓我們透過推測設計思維去思考著當面對未知未來時，「這個世界可能會變成什麼樣子？」這個重要的提問。",
          "locationName": "1102",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ae14e984-b8a3-4c44-abd9-1ea32ee37583",
          "title": "春池循環設計的各種實踐與未來",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "在氣候變遷與溫室效應影響著我們的生活，循環經濟與循環設計變成一個重要未來課題。 「我們過去的需求都是消耗，但我們想塑造的未來是，把未來的需求都成為新的創造。」春池玻璃未來將繼續以循環玻璃為載體，希望影響更多產業走向循環經濟。\n\n春池玻璃，目前跨足於工業原料、科技建材、文化藝術與觀光工廠。本業為專業回收玻璃與再處理之企業，總公司在台灣新竹，並擁有三家相關企業。目前每年回收並處理超過 10 萬噸的春池玻璃，目前為全台最具規模之廢棄玻璃回收業者。其企業理念為永續經營，綠色創新。在 2015 更獲得根留台灣，展望全球之「金根獎」之殊榮。蔡總統英文更在 2016 年 9 月親自參訪春池玻璃觀光工廠，並給予極高評價，稱春池玻璃為台灣「循環經濟」之典範。更在 2017 年獲得 British Chamber of Commerce 之 Better Business Award 社會企業首獎。更在 2018 年獲得總統創新獎與艾森豪獎金學人殊榮",
          "locationName": "1103",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        }
      ]
    },
    {
      "date": "2021-10-08",
      "sessions": [
        {
          "uuid": "08724314-8b0d-4b8b-bc97-aaf5870b4725",
          "title": "08年會開幕",
          "startTime": "09:30",
          "endTime": "09:45",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "開幕式",
          "description": "開幕式",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [
            {
              "uuid": "F2110Wv8",
              "categoryTitle": "課程檔案",
              "title": "課程檔案",
              "description": null,
              "size": "Bytes",
              "publishUp": null,
              "downloadLink": "http://zerone.test/api/file/download/F2110Wv8",
              "contentType": "application/pdf"
            }
          ],
          "link": null
        },
        {
          "uuid": "6f0fbac6-ea7d-4c9d-b46d-5f8840c1d826",
          "title": "Making Digital Tangible: The Battle Against the Pixel Empire",
          "startTime": "09:45",
          "endTime": "10:55",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 1,
          "linkOpeningTime": null,
          "introtext": "數位資訊實體化：一場與像素帝國抗衡的戰役",
          "description": "時下人機互動的主流研究大多關注實用層面－使用者需求、實際的應用系統，與易用性評估。Tangible Bits 和 Radical Atoms 則是願景驅動的研究，並以藝術取向執行。現今社會一項技術可能一年後就過時了，一個應用系統可能十年後就遭取代。但我們相信，一個真正的願景，能持續發揮影響超過百年。\n\nTangible Bits 的研究目的是實現打造人、數位資訊，與實體環境之間無接縫的介面（Seamless Interfaces），為數位資訊與運算提供實體介面，讓人們可以直接操控位元（bits），也能感知其存在，無論是在前景或背景意識之下（foreground and background of our consciousness）。我們的目標是發明新的設計媒介，不但能適用於科學分析，也應用在藝術表達。Tangible Bits 的研究理念除了利用即時感知與數位回饋帶來的運算呈現外，也充分利用人類豐富的感官能力，與人們ㄧ生與實體世界互動的多樣技能。",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "91312205-2007-4800-82fe-625f520c2ff0",
          "title": "休息交流時間",
          "startTime": "10:50",
          "endTime": "11:10",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "",
          "locationName": "11樓休息區",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "6bffa1c5-a89f-4468-a386-c7b448d6b2c6",
          "title": "漸進式的改革與創新 - 後疫情時代的設計體驗轉型",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "產品會隨著人們的生活一起演進，歷史悠久的產品，會發展出深根蒂固的使用習慣，企業內部也有完整的流程與堅實企業文化。然而，習慣與框架有時會成為設計師推進創新的門檻。 Lydia將透過幾個Yahoo奇摩在台灣與Verizon Media在歐洲線的產品開發實例，分享這幾年如何以體驗式設計帶領團隊走進使用者的生活，並且將同理心應用在同事和決策者身上，進而打破既有設計規範、跨國文化，讓體驗文化在組織中發酵，漸進式的改革並創造與時俱進的產品在不同市場中。\n\n我們都期待改革是快速與有效的，但很多時候使用者多年的使用體驗已經定型，Lydia 帶領的 Verizon Media 設計團隊從前期策略規劃、使用者體驗訪談到設計開發與上線後監測優化都有一套完整流程，並帶動合作部門推進創新維度與執行。本次將分享在改革的腳步中，如何加快企業內部的接受度、開發與溝通的速度，並透過設計管理，讓這樣的成功案例可以跨國推進、建立 SOP ; 更重要的是，聚沙成塔，如何有規劃與節奏的讓使用者漸進式轉移，擁抱新的體驗設計，並因應不同市場的快速變化，Lydia也將分享幾個後疫情時代，產品快速調整的實際案例。",
          "locationName": "1101",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ebe86034-7fda-464b-bebe-081f35d9703a",
          "title": "設計作為一種推測與思想實驗",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            },
            {
              "name": "王小明2",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "「我們的現實世界被無垠的可能世界所包圍。」\n\nLubomír Doležel, Heterocosmica: Fiction and Possible Worlds, 1999\n2005年從英國皇家藝術學院（Royal College of Art）設計互動系（Design Interactions）開始慢慢萌芽的推測設計（Speculative Design）思維，經過十幾年之後，近年來在西方世界的設計、藝術文化領域，引起了廣大的影響與辯論，而很多專家也認為推測設計是「推測未來」的重要方法之一，而在東方世界，這股氛圍也緩緩升起中。\n\n「設計」如何作為一種推測、如何作為一種思想實驗？本次講座的講者宮保睿，試著帶領你從推測設計的發源起點、思維方式、現在狀況、可能未來、創作與教學實踐來解析各種面向，試著讓我們透過推測設計思維去思考著當面對未知未來時，「這個世界可能會變成什麼樣子？」這個重要的提問。",
          "locationName": "1102",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ae14e984-b8a3-4c44-abd9-1ea32ee37583",
          "title": "春池循環設計的各種實踐與未來",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "在氣候變遷與溫室效應影響著我們的生活，循環經濟與循環設計變成一個重要未來課題。 「我們過去的需求都是消耗，但我們想塑造的未來是，把未來的需求都成為新的創造。」春池玻璃未來將繼續以循環玻璃為載體，希望影響更多產業走向循環經濟。\n\n春池玻璃，目前跨足於工業原料、科技建材、文化藝術與觀光工廠。本業為專業回收玻璃與再處理之企業，總公司在台灣新竹，並擁有三家相關企業。目前每年回收並處理超過 10 萬噸的春池玻璃，目前為全台最具規模之廢棄玻璃回收業者。其企業理念為永續經營，綠色創新。在 2015 更獲得根留台灣，展望全球之「金根獎」之殊榮。蔡總統英文更在 2016 年 9 月親自參訪春池玻璃觀光工廠，並給予極高評價，稱春池玻璃為台灣「循環經濟」之典範。更在 2017 年獲得 British Chamber of Commerce 之 Better Business Award 社會企業首獎。更在 2018 年獲得總統創新獎與艾森豪獎金學人殊榮",
          "locationName": "1103",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        }
      ]
    },
  ]
};

// 線上 單天 統一報名
export const FAKE_EVENT_ITEM_PHYSICAL_SINGLE_ONLINE = {
  "title": "IxDTW 互動設計年會 2021（線上單天統一）",
  "alias": "alias",
  "seriesNum": "seriesNum",
  "state": 1,
  "type": "online",
  "dateType": "single",
  "chargeType": "impartial",
  "dateTimeRange": "2021/10/03(六) (08:00~22:00)",
  "registrationType": "impartial",
  "registrationStartDate": "2021-08-26 07:59:59",
  "registrationEndDate": "2021-10-02 23:59:59",
  "inProgress": 1,
  "hasAbsentLimit": 0,
  "absentLimit": 1,
  "canApply": 1,
  "basePrice": 0,
  "salePrice": 0,
  "link": "https://youtu.be/acefhx",
  "bannerImage": "banner.png",
  "slideshow": [
    {
      "path": "slideshow1.png",
      "default": 1
    },
    {
      "path": "slideshow2.png",
      "default": 0
    }
  ],
  "introtext": "設計下一個十年 - 多元與躍進",
  "description": "IxDTW 互動設計年會是 2021 年台灣主要的互動設計與使用者體驗設計的論壇。將於台北舉行，我們即將邀請 25 ~30 位來自國內外產官學界的設計專家及知名講者，分享他們的思維與經驗，以及在設計產品中所遇到的挑戰，讓會眾拓展跨職能的視野。\n\n今年，以「多元與躍進」作為大會主軸，帶領會眾共同思考下一個十年會朝那些趨勢前進，而多元文化是如何影響我們的生活及設計方式，形成新的意義。先行者們，持續躍進及挑戰的過程，將有助我們理解產業的變動，設計師將其價值轉化為設計行動，結合在地優勢面向全世界。",
  "locationName": "張榮發國際會議中心",
  "city": "臺北市",
  "district": "中正區",
  "address": "中山南路11號11樓",
  "zipcode": "101",
  "lat": 25.1234567,
  "lng": 121.02564,
  "canRegisterGroup": 7,
  "requireCoupon": 0,
  "phoneCode": "02",
  "phone": "25316628",
  "needReview": 1,
  "params": [],
  "meals": [
    {
      "id": 3,
      "date": "2021-10-03",
      "options": [
        "葷食餐點",
        "素食餐點"
      ],
      "params": []
    },
    {
      "id": 4,
      "date": "2021-10-04",
      "options": [
        "炙燒北海道干貝丼",
        "炙燒北海道干貝丼",
        "馬糞海膽散壽司"
      ],
      "params": []
    }
  ],
  "questions": [
    {
      "title": "感興趣的議題",
      "state": 1,
      "type": "select",
      "value": "",
      "required": 1,
      "description": "請選擇感興趣的議題",
      "params": {
        "options": [
          "資訊安全",
          "虛擬化",
          "AI大數據"
        ]
      }
    }
  ],
  "files": [
    {
      "uuid": "F2110Wv8",
      "categoryTitle": "課程檔案",
      "title": "課程檔案",
      "description": null,
      "size": "Bytes",
      "publishUp": null,
      "downloadLink": "http://zerone.test/api/file/download/F2110Wv8"
    }
  ],
  "sponsors": [
    {
      "title": "Microsoft",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://microsoft.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    }
  ],
  "brands": [
    {
      "title": "BlcakBerry",
      "alias": "blcakberry",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "contact": [
        {
          "name": "王小明",
          "gender": "先生",
          "countryCode": "02",
          "phone": "22221234",
          "extension": "1111"
        },
        {
          "name": "林小花",
          "gender": "先生",
          "countryCode": "02",
          "phone": "22225566",
          "extension": "2222"
        }
      ]
    },
    {
      "title": "VMware",
      "alias": "vmware",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "contact": [
        {
          "name": "王小明",
          "gender": "先生",
          "countryCode": "02",
          "phone": "22221234",
          "extension": "1111"
        },
      ]
    }
  ],
  "sessions": [
    {
      "date": "2021-10-18",
      "sessions": [
        {
          "uuid": "08724314-8b0d-4b8b-bc97-aaf5870b4725",
          "title": "年會開幕",
          "startTime": "09:30",
          "endTime": "09:45",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "開幕式",
          "description": "開幕式",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [
            {
              "uuid": "F2110Wv8",
              "categoryTitle": "課程檔案",
              "title": "課程檔案",
              "description": null,
              "size": "Bytes",
              "publishUp": null,
              "downloadLink": "http://zerone.test/api/file/download/F2110Wv8",
              "contentType": "application/pdf"
            }
          ],
          "link": null
        },
        {
          "uuid": "6f0fbac6-ea7d-4c9d-b46d-5f8840c1d826",
          "title": "Making Digital Tangible: The Battle Against the Pixel Empire",
          "startTime": "09:45",
          "endTime": "10:55",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 1,
          "linkOpeningTime": null,
          "introtext": "數位資訊實體化：一場與像素帝國抗衡的戰役",
          "description": "時下人機互動的主流研究大多關注實用層面－使用者需求、實際的應用系統，與易用性評估。Tangible Bits 和 Radical Atoms 則是願景驅動的研究，並以藝術取向執行。現今社會一項技術可能一年後就過時了，一個應用系統可能十年後就遭取代。但我們相信，一個真正的願景，能持續發揮影響超過百年。\n\nTangible Bits 的研究目的是實現打造人、數位資訊，與實體環境之間無接縫的介面（Seamless Interfaces），為數位資訊與運算提供實體介面，讓人們可以直接操控位元（bits），也能感知其存在，無論是在前景或背景意識之下（foreground and background of our consciousness）。我們的目標是發明新的設計媒介，不但能適用於科學分析，也應用在藝術表達。Tangible Bits 的研究理念除了利用即時感知與數位回饋帶來的運算呈現外，也充分利用人類豐富的感官能力，與人們ㄧ生與實體世界互動的多樣技能。",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "91312205-2007-4800-82fe-625f520c2ff0",
          "title": "休息交流時間",
          "startTime": "10:50",
          "endTime": "11:10",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "",
          "locationName": "11樓休息區",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "6bffa1c5-a89f-4468-a386-c7b448d6b2c6",
          "title": "漸進式的改革與創新 - 後疫情時代的設計體驗轉型",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "產品會隨著人們的生活一起演進，歷史悠久的產品，會發展出深根蒂固的使用習慣，企業內部也有完整的流程與堅實企業文化。然而，習慣與框架有時會成為設計師推進創新的門檻。 Lydia將透過幾個Yahoo奇摩在台灣與Verizon Media在歐洲線的產品開發實例，分享這幾年如何以體驗式設計帶領團隊走進使用者的生活，並且將同理心應用在同事和決策者身上，進而打破既有設計規範、跨國文化，讓體驗文化在組織中發酵，漸進式的改革並創造與時俱進的產品在不同市場中。\n\n我們都期待改革是快速與有效的，但很多時候使用者多年的使用體驗已經定型，Lydia 帶領的 Verizon Media 設計團隊從前期策略規劃、使用者體驗訪談到設計開發與上線後監測優化都有一套完整流程，並帶動合作部門推進創新維度與執行。本次將分享在改革的腳步中，如何加快企業內部的接受度、開發與溝通的速度，並透過設計管理，讓這樣的成功案例可以跨國推進、建立 SOP ; 更重要的是，聚沙成塔，如何有規劃與節奏的讓使用者漸進式轉移，擁抱新的體驗設計，並因應不同市場的快速變化，Lydia也將分享幾個後疫情時代，產品快速調整的實際案例。",
          "locationName": "1101",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ebe86034-7fda-464b-bebe-081f35d9703a",
          "title": "設計作為一種推測與思想實驗",
          "startTime": "13:10",
          "endTime": "15:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            },
            {
              "name": "王小明2",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "「我們的現實世界被無垠的可能世界所包圍。」\n\nLubomír Doležel, Heterocosmica: Fiction and Possible Worlds, 1999\n2005年從英國皇家藝術學院（Royal College of Art）設計互動系（Design Interactions）開始慢慢萌芽的推測設計（Speculative Design）思維，經過十幾年之後，近年來在西方世界的設計、藝術文化領域，引起了廣大的影響與辯論，而很多專家也認為推測設計是「推測未來」的重要方法之一，而在東方世界，這股氛圍也緩緩升起中。\n\n「設計」如何作為一種推測、如何作為一種思想實驗？本次講座的講者宮保睿，試著帶領你從推測設計的發源起點、思維方式、現在狀況、可能未來、創作與教學實踐來解析各種面向，試著讓我們透過推測設計思維去思考著當面對未知未來時，「這個世界可能會變成什麼樣子？」這個重要的提問。",
          "locationName": "1102",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ae14e984-b8a3-4c44-abd9-1ea32ee37583",
          "title": "春池循環設計的各種實踐與未來",
          "startTime": "17:10",
          "endTime": "19:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "在氣候變遷與溫室效應影響著我們的生活，循環經濟與循環設計變成一個重要未來課題。 「我們過去的需求都是消耗，但我們想塑造的未來是，把未來的需求都成為新的創造。」春池玻璃未來將繼續以循環玻璃為載體，希望影響更多產業走向循環經濟。\n\n春池玻璃，目前跨足於工業原料、科技建材、文化藝術與觀光工廠。本業為專業回收玻璃與再處理之企業，總公司在台灣新竹，並擁有三家相關企業。目前每年回收並處理超過 10 萬噸的春池玻璃，目前為全台最具規模之廢棄玻璃回收業者。其企業理念為永續經營，綠色創新。在 2015 更獲得根留台灣，展望全球之「金根獎」之殊榮。蔡總統英文更在 2016 年 9 月親自參訪春池玻璃觀光工廠，並給予極高評價，稱春池玻璃為台灣「循環經濟」之典範。更在 2017 年獲得 British Chamber of Commerce 之 Better Business Award 社會企業首獎。更在 2018 年獲得總統創新獎與艾森豪獎金學人殊榮",
          "locationName": "1103",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        }
      ]
    },
  ]
};

// 線上 多天 分場次報名
export const FAKE_EVENT_ITEM_PHYSICAL_MULTIPLE_ONLINE = {
  "title": "IxDTW 互動設計年會 2021（實體多天統一）",
  "alias": "alias",
  "seriesNum": "seriesNum",
  "state": 1,
  "type": "online", // 線上
  "dateType": "multiple", // 多天
  "chargeType": "impartial",
  "dateTimeRange": "2021/10/17(日)～ 2021/10/20(三)",
  "registrationType": "partial", // 分場次
  "registrationStartDate": "2021-08-26 07:59:59",
  "registrationEndDate": "2022-10-02 23:59:59",
  "inProgress": 1,
  "hasAbsentLimit": 0,
  "absentLimit": 1,
  "canApply": 0,
  "basePrice": 0,
  "salePrice": 0,
  "link": "https://youtu.be/acefhx",
  "bannerImage": "banner.png",
  "slideshow": [
    {
      "path": "slideshow1.png",
      "default": 1
    },
    {
      "path": "slideshow2.png",
      "default": 0
    }
  ],
  "introtext": "設計下一個十年 - 多元與躍進",
  "description": "IxDTW 互動設計年會是 2021 年台灣主要的互動設計與使用者體驗設計的論壇。將於台北舉行，我們即將邀請 25 ~30 位來自國內外產官學界的設計專家及知名講者，分享他們的思維與經驗，以及在設計產品中所遇到的挑戰，讓會眾拓展跨職能的視野。\n\n今年，以「多元與躍進」作為大會主軸，帶領會眾共同思考下一個十年會朝那些趨勢前進，而多元文化是如何影響我們的生活及設計方式，形成新的意義。先行者們，持續躍進及挑戰的過程，將有助我們理解產業的變動，設計師將其價值轉化為設計行動，結合在地優勢面向全世界。",
  "locationName": "張榮發國際會議中心",
  "city": "臺北市",
  "district": "中正區",
  "address": "中山南路11號11樓",
  "zipcode": "101",
  "lat": 25.1234567,
  "lng": 121.02564,
  "canRegisterGroup": 7,
  "requireCoupon": 1,
  "phoneCode": "02",
  "phone": "25316628",
  "needReview": 1,
  "params": [],
  "meals": [
    {
      "id": 3,
      "date": "2021-10-17",
      "options": [
        "葷食餐點",
        "素食餐點"
      ],
      "params": []
    },
    {
      "id": 4,
      "date": "2021-10-18",
      "options": [
        "炙燒北海道干貝丼",
        "炙燒北海道干貝丼",
        "馬糞海膽散壽司"
      ],
      "params": []
    },
    {
      "id": 5,
      "date": "2021-10-19",
      "options": [
        "炙燒北海道干貝丼",
        "炙燒北海道干貝丼",
        "馬糞海膽散壽司"
      ],
      "params": []
    },
    {
      "id": 6,
      "date": "2021-10-20",
      "options": [
        "炙燒北海道干貝丼",
        "炙燒北海道干貝丼",
        "馬糞海膽散壽司"
      ],
      "params": []
    },
  ],
  "questions": [
    {
      "title": "感興趣的議題",
      "state": 1,
      "type": "select",
      "value": "",
      "required": 1,
      "description": "請選擇感興趣的議題",
      "params": {
        "options": [
          "資訊安全",
          "虛擬化",
          "AI大數據"
        ]
      }
    }
  ],
  "files": [
    {
      "uuid": "F2110Wv8",
      "categoryTitle": "課程檔案",
      "title": "課程檔案",
      "description": null,
      "size": "Bytes",
      "publishUp": null,
      "downloadLink": "http://zerone.test/api/file/download/F2110Wv8"
    }
  ],
  "sponsors": [
    {
      "title": "Microsoft",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://microsoft.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    },
    {
      "title": "Google",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "link": "https://google.com",
    }
  ],
  "brands": [
    {
      "title": "BlcakBerry",
      "alias": "blcakberry",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "contact": [
        {
          "name": "王小明",
          "gender": "先生",
          "countryCode": "02",
          "phone": "22221234",
          "extension": "1111"
        },
        {
          "name": "林小花",
          "gender": "先生",
          "countryCode": "02",
          "phone": "22225566",
          "extension": "2222"
        }
      ]
    },
    {
      "title": "VMware",
      "alias": "vmware",
      "logo": "https://assets.codepen.io/1759070/logo_1.svg",
      "contact": [
        {
          "name": "王小明",
          "gender": "先生",
          "countryCode": "02",
          "phone": "22221234",
          "extension": "1111"
        },
      ]
    }
  ],
  "sessions": [
    {
      "date": "2021-10-17",
      "sessions": [
        {
          "uuid": "08724314-8b0d-4b8b-bc97-aaf5870b4725",
          "title": "年會開幕",
          "startTime": "09:30",
          "endTime": "09:45",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "開幕式",
          "description": "開幕式",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [
            {
              "uuid": "F2110Wv8",
              "categoryTitle": "課程檔案",
              "title": "課程檔案",
              "description": null,
              "size": "Bytes",
              "publishUp": null,
              "downloadLink": "http://zerone.test/api/file/download/F2110Wv8",
              "contentType": "application/pdf"
            }
          ],
          "link": null
        },
        {
          "uuid": "6f0fbac6-ea7d-4c9d-b46d-5f8840c1d826",
          "title": "Making Digital Tangible: The Battle Against the Pixel Empire",
          "startTime": "09:45",
          "endTime": "10:55",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 1,
          "linkOpeningTime": null,
          "introtext": "數位資訊實體化：一場與像素帝國抗衡的戰役",
          "description": "時下人機互動的主流研究大多關注實用層面－使用者需求、實際的應用系統，與易用性評估。Tangible Bits 和 Radical Atoms 則是願景驅動的研究，並以藝術取向執行。現今社會一項技術可能一年後就過時了，一個應用系統可能十年後就遭取代。但我們相信，一個真正的願景，能持續發揮影響超過百年。\n\nTangible Bits 的研究目的是實現打造人、數位資訊，與實體環境之間無接縫的介面（Seamless Interfaces），為數位資訊與運算提供實體介面，讓人們可以直接操控位元（bits），也能感知其存在，無論是在前景或背景意識之下（foreground and background of our consciousness）。我們的目標是發明新的設計媒介，不但能適用於科學分析，也應用在藝術表達。Tangible Bits 的研究理念除了利用即時感知與數位回饋帶來的運算呈現外，也充分利用人類豐富的感官能力，與人們ㄧ生與實體世界互動的多樣技能。",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "91312205-2007-4800-82fe-625f520c2ff0",
          "title": "休息交流時間",
          "startTime": "10:50",
          "endTime": "11:10",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "",
          "locationName": "11樓休息區",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "6bffa1c5-a89f-4468-a386-c7b448d6b2c6",
          "title": "漸進式的改革與創新 - 後疫情時代的設計體驗轉型",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "產品會隨著人們的生活一起演進，歷史悠久的產品，會發展出深根蒂固的使用習慣，企業內部也有完整的流程與堅實企業文化。然而，習慣與框架有時會成為設計師推進創新的門檻。 Lydia將透過幾個Yahoo奇摩在台灣與Verizon Media在歐洲線的產品開發實例，分享這幾年如何以體驗式設計帶領團隊走進使用者的生活，並且將同理心應用在同事和決策者身上，進而打破既有設計規範、跨國文化，讓體驗文化在組織中發酵，漸進式的改革並創造與時俱進的產品在不同市場中。\n\n我們都期待改革是快速與有效的，但很多時候使用者多年的使用體驗已經定型，Lydia 帶領的 Verizon Media 設計團隊從前期策略規劃、使用者體驗訪談到設計開發與上線後監測優化都有一套完整流程，並帶動合作部門推進創新維度與執行。本次將分享在改革的腳步中，如何加快企業內部的接受度、開發與溝通的速度，並透過設計管理，讓這樣的成功案例可以跨國推進、建立 SOP ; 更重要的是，聚沙成塔，如何有規劃與節奏的讓使用者漸進式轉移，擁抱新的體驗設計，並因應不同市場的快速變化，Lydia也將分享幾個後疫情時代，產品快速調整的實際案例。",
          "locationName": "1101",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ebe86034-7fda-464b-bebe-081f35d9703a",
          "title": "設計作為一種推測與思想實驗",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            },
            {
              "name": "王小明2",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "「我們的現實世界被無垠的可能世界所包圍。」\n\nLubomír Doležel, Heterocosmica: Fiction and Possible Worlds, 1999\n2005年從英國皇家藝術學院（Royal College of Art）設計互動系（Design Interactions）開始慢慢萌芽的推測設計（Speculative Design）思維，經過十幾年之後，近年來在西方世界的設計、藝術文化領域，引起了廣大的影響與辯論，而很多專家也認為推測設計是「推測未來」的重要方法之一，而在東方世界，這股氛圍也緩緩升起中。\n\n「設計」如何作為一種推測、如何作為一種思想實驗？本次講座的講者宮保睿，試著帶領你從推測設計的發源起點、思維方式、現在狀況、可能未來、創作與教學實踐來解析各種面向，試著讓我們透過推測設計思維去思考著當面對未知未來時，「這個世界可能會變成什麼樣子？」這個重要的提問。",
          "locationName": "1102",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ae14e984-b8a3-4c44-abd9-1ea32ee37583",
          "title": "春池循環設計的各種實踐與未來",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "在氣候變遷與溫室效應影響著我們的生活，循環經濟與循環設計變成一個重要未來課題。 「我們過去的需求都是消耗，但我們想塑造的未來是，把未來的需求都成為新的創造。」春池玻璃未來將繼續以循環玻璃為載體，希望影響更多產業走向循環經濟。\n\n春池玻璃，目前跨足於工業原料、科技建材、文化藝術與觀光工廠。本業為專業回收玻璃與再處理之企業，總公司在台灣新竹，並擁有三家相關企業。目前每年回收並處理超過 10 萬噸的春池玻璃，目前為全台最具規模之廢棄玻璃回收業者。其企業理念為永續經營，綠色創新。在 2015 更獲得根留台灣，展望全球之「金根獎」之殊榮。蔡總統英文更在 2016 年 9 月親自參訪春池玻璃觀光工廠，並給予極高評價，稱春池玻璃為台灣「循環經濟」之典範。更在 2017 年獲得 British Chamber of Commerce 之 Better Business Award 社會企業首獎。更在 2018 年獲得總統創新獎與艾森豪獎金學人殊榮",
          "locationName": "1103",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        }
      ]
    },
    {
      "date": "2021-10-18",
      "sessions": [
        {
          "uuid": "08724314-8b0d-4b8b-bc97-aaf5870b4725",
          "title": "04年會開幕",
          "startTime": "09:30",
          "endTime": "09:45",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "開幕式",
          "description": "開幕式",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [
            {
              "uuid": "F2110Wv8",
              "categoryTitle": "課程檔案",
              "title": "課程檔案",
              "description": null,
              "size": "Bytes",
              "publishUp": null,
              "downloadLink": "http://zerone.test/api/file/download/F2110Wv8",
              "contentType": "application/pdf"
            }
          ],
          "link": null
        },
        {
          "uuid": "6f0fbac6-ea7d-4c9d-b46d-5f8840c1d826",
          "title": "Making Digital Tangible: The Battle Against the Pixel Empire",
          "startTime": "09:45",
          "endTime": "10:55",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 1,
          "linkOpeningTime": null,
          "introtext": "數位資訊實體化：一場與像素帝國抗衡的戰役",
          "description": "時下人機互動的主流研究大多關注實用層面－使用者需求、實際的應用系統，與易用性評估。Tangible Bits 和 Radical Atoms 則是願景驅動的研究，並以藝術取向執行。現今社會一項技術可能一年後就過時了，一個應用系統可能十年後就遭取代。但我們相信，一個真正的願景，能持續發揮影響超過百年。\n\nTangible Bits 的研究目的是實現打造人、數位資訊，與實體環境之間無接縫的介面（Seamless Interfaces），為數位資訊與運算提供實體介面，讓人們可以直接操控位元（bits），也能感知其存在，無論是在前景或背景意識之下（foreground and background of our consciousness）。我們的目標是發明新的設計媒介，不但能適用於科學分析，也應用在藝術表達。Tangible Bits 的研究理念除了利用即時感知與數位回饋帶來的運算呈現外，也充分利用人類豐富的感官能力，與人們ㄧ生與實體世界互動的多樣技能。",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "91312205-2007-4800-82fe-625f520c2ff0",
          "title": "休息交流時間",
          "startTime": "10:50",
          "endTime": "11:10",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "",
          "locationName": "11樓休息區",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "6bffa1c5-a89f-4468-a386-c7b448d6b2c6",
          "title": "漸進式的改革與創新 - 後疫情時代的設計體驗轉型",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "產品會隨著人們的生活一起演進，歷史悠久的產品，會發展出深根蒂固的使用習慣，企業內部也有完整的流程與堅實企業文化。然而，習慣與框架有時會成為設計師推進創新的門檻。 Lydia將透過幾個Yahoo奇摩在台灣與Verizon Media在歐洲線的產品開發實例，分享這幾年如何以體驗式設計帶領團隊走進使用者的生活，並且將同理心應用在同事和決策者身上，進而打破既有設計規範、跨國文化，讓體驗文化在組織中發酵，漸進式的改革並創造與時俱進的產品在不同市場中。\n\n我們都期待改革是快速與有效的，但很多時候使用者多年的使用體驗已經定型，Lydia 帶領的 Verizon Media 設計團隊從前期策略規劃、使用者體驗訪談到設計開發與上線後監測優化都有一套完整流程，並帶動合作部門推進創新維度與執行。本次將分享在改革的腳步中，如何加快企業內部的接受度、開發與溝通的速度，並透過設計管理，讓這樣的成功案例可以跨國推進、建立 SOP ; 更重要的是，聚沙成塔，如何有規劃與節奏的讓使用者漸進式轉移，擁抱新的體驗設計，並因應不同市場的快速變化，Lydia也將分享幾個後疫情時代，產品快速調整的實際案例。",
          "locationName": "1101",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ebe86034-7fda-464b-bebe-081f35d9703a",
          "title": "設計作為一種推測與思想實驗",
          "startTime": "13:10",
          "endTime": "17:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            },
            {
              "name": "王小明2",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "「我們的現實世界被無垠的可能世界所包圍。」\n\nLubomír Doležel, Heterocosmica: Fiction and Possible Worlds, 1999\n2005年從英國皇家藝術學院（Royal College of Art）設計互動系（Design Interactions）開始慢慢萌芽的推測設計（Speculative Design）思維，經過十幾年之後，近年來在西方世界的設計、藝術文化領域，引起了廣大的影響與辯論，而很多專家也認為推測設計是「推測未來」的重要方法之一，而在東方世界，這股氛圍也緩緩升起中。\n\n「設計」如何作為一種推測、如何作為一種思想實驗？本次講座的講者宮保睿，試著帶領你從推測設計的發源起點、思維方式、現在狀況、可能未來、創作與教學實踐來解析各種面向，試著讓我們透過推測設計思維去思考著當面對未知未來時，「這個世界可能會變成什麼樣子？」這個重要的提問。",
          "locationName": "1102",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ae14e984-b8a3-4c44-abd9-1ea32ee37583",
          "title": "春池循環設計的各種實踐與未來",
          "startTime": "17:10",
          "endTime": "19:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "在氣候變遷與溫室效應影響著我們的生活，循環經濟與循環設計變成一個重要未來課題。 「我們過去的需求都是消耗，但我們想塑造的未來是，把未來的需求都成為新的創造。」春池玻璃未來將繼續以循環玻璃為載體，希望影響更多產業走向循環經濟。\n\n春池玻璃，目前跨足於工業原料、科技建材、文化藝術與觀光工廠。本業為專業回收玻璃與再處理之企業，總公司在台灣新竹，並擁有三家相關企業。目前每年回收並處理超過 10 萬噸的春池玻璃，目前為全台最具規模之廢棄玻璃回收業者。其企業理念為永續經營，綠色創新。在 2015 更獲得根留台灣，展望全球之「金根獎」之殊榮。蔡總統英文更在 2016 年 9 月親自參訪春池玻璃觀光工廠，並給予極高評價，稱春池玻璃為台灣「循環經濟」之典範。更在 2017 年獲得 British Chamber of Commerce 之 Better Business Award 社會企業首獎。更在 2018 年獲得總統創新獎與艾森豪獎金學人殊榮",
          "locationName": "1103",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        }
      ]
    },
    {
      "date": "2021-10-19",
      "sessions": [
        {
          "uuid": "08724314-8b0d-4b8b-bc97-aaf5870b4725",
          "title": "05年會開幕",
          "startTime": "09:30",
          "endTime": "09:45",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "開幕式",
          "description": "開幕式",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [
            {
              "uuid": "F2110Wv8",
              "categoryTitle": "課程檔案",
              "title": "課程檔案",
              "description": null,
              "size": "Bytes",
              "publishUp": null,
              "downloadLink": "http://zerone.test/api/file/download/F2110Wv8",
              "contentType": "application/pdf"
            }
          ],
          "link": null
        },
        {
          "uuid": "6f0fbac6-ea7d-4c9d-b46d-5f8840c1d826",
          "title": "Making Digital Tangible: The Battle Against the Pixel Empire",
          "startTime": "09:45",
          "endTime": "10:55",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 1,
          "linkOpeningTime": null,
          "introtext": "數位資訊實體化：一場與像素帝國抗衡的戰役",
          "description": "時下人機互動的主流研究大多關注實用層面－使用者需求、實際的應用系統，與易用性評估。Tangible Bits 和 Radical Atoms 則是願景驅動的研究，並以藝術取向執行。現今社會一項技術可能一年後就過時了，一個應用系統可能十年後就遭取代。但我們相信，一個真正的願景，能持續發揮影響超過百年。\n\nTangible Bits 的研究目的是實現打造人、數位資訊，與實體環境之間無接縫的介面（Seamless Interfaces），為數位資訊與運算提供實體介面，讓人們可以直接操控位元（bits），也能感知其存在，無論是在前景或背景意識之下（foreground and background of our consciousness）。我們的目標是發明新的設計媒介，不但能適用於科學分析，也應用在藝術表達。Tangible Bits 的研究理念除了利用即時感知與數位回饋帶來的運算呈現外，也充分利用人類豐富的感官能力，與人們ㄧ生與實體世界互動的多樣技能。",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "91312205-2007-4800-82fe-625f520c2ff0",
          "title": "休息交流時間",
          "startTime": "10:50",
          "endTime": "11:10",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "",
          "locationName": "11樓休息區",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "6bffa1c5-a89f-4468-a386-c7b448d6b2c6",
          "title": "漸進式的改革與創新 - 後疫情時代的設計體驗轉型",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "產品會隨著人們的生活一起演進，歷史悠久的產品，會發展出深根蒂固的使用習慣，企業內部也有完整的流程與堅實企業文化。然而，習慣與框架有時會成為設計師推進創新的門檻。 Lydia將透過幾個Yahoo奇摩在台灣與Verizon Media在歐洲線的產品開發實例，分享這幾年如何以體驗式設計帶領團隊走進使用者的生活，並且將同理心應用在同事和決策者身上，進而打破既有設計規範、跨國文化，讓體驗文化在組織中發酵，漸進式的改革並創造與時俱進的產品在不同市場中。\n\n我們都期待改革是快速與有效的，但很多時候使用者多年的使用體驗已經定型，Lydia 帶領的 Verizon Media 設計團隊從前期策略規劃、使用者體驗訪談到設計開發與上線後監測優化都有一套完整流程，並帶動合作部門推進創新維度與執行。本次將分享在改革的腳步中，如何加快企業內部的接受度、開發與溝通的速度，並透過設計管理，讓這樣的成功案例可以跨國推進、建立 SOP ; 更重要的是，聚沙成塔，如何有規劃與節奏的讓使用者漸進式轉移，擁抱新的體驗設計，並因應不同市場的快速變化，Lydia也將分享幾個後疫情時代，產品快速調整的實際案例。",
          "locationName": "1101",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ebe86034-7fda-464b-bebe-081f35d9703a",
          "title": "設計作為一種推測與思想實驗",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            },
            {
              "name": "王小明2",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "「我們的現實世界被無垠的可能世界所包圍。」\n\nLubomír Doležel, Heterocosmica: Fiction and Possible Worlds, 1999\n2005年從英國皇家藝術學院（Royal College of Art）設計互動系（Design Interactions）開始慢慢萌芽的推測設計（Speculative Design）思維，經過十幾年之後，近年來在西方世界的設計、藝術文化領域，引起了廣大的影響與辯論，而很多專家也認為推測設計是「推測未來」的重要方法之一，而在東方世界，這股氛圍也緩緩升起中。\n\n「設計」如何作為一種推測、如何作為一種思想實驗？本次講座的講者宮保睿，試著帶領你從推測設計的發源起點、思維方式、現在狀況、可能未來、創作與教學實踐來解析各種面向，試著讓我們透過推測設計思維去思考著當面對未知未來時，「這個世界可能會變成什麼樣子？」這個重要的提問。",
          "locationName": "1102",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ae14e984-b8a3-4c44-abd9-1ea32ee37583",
          "title": "春池循環設計的各種實踐與未來",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "在氣候變遷與溫室效應影響著我們的生活，循環經濟與循環設計變成一個重要未來課題。 「我們過去的需求都是消耗，但我們想塑造的未來是，把未來的需求都成為新的創造。」春池玻璃未來將繼續以循環玻璃為載體，希望影響更多產業走向循環經濟。\n\n春池玻璃，目前跨足於工業原料、科技建材、文化藝術與觀光工廠。本業為專業回收玻璃與再處理之企業，總公司在台灣新竹，並擁有三家相關企業。目前每年回收並處理超過 10 萬噸的春池玻璃，目前為全台最具規模之廢棄玻璃回收業者。其企業理念為永續經營，綠色創新。在 2015 更獲得根留台灣，展望全球之「金根獎」之殊榮。蔡總統英文更在 2016 年 9 月親自參訪春池玻璃觀光工廠，並給予極高評價，稱春池玻璃為台灣「循環經濟」之典範。更在 2017 年獲得 British Chamber of Commerce 之 Better Business Award 社會企業首獎。更在 2018 年獲得總統創新獎與艾森豪獎金學人殊榮",
          "locationName": "1103",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        }
      ]
    },
    {
      "date": "2021-10-20",
      "sessions": [
        {
          "uuid": "08724314-8b0d-4b8b-bc97-aaf5870b4725",
          "title": "06年會開幕",
          "startTime": "09:30",
          "endTime": "09:45",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "開幕式",
          "description": "開幕式",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [
            {
              "uuid": "F2110Wv8",
              "categoryTitle": "課程檔案",
              "title": "課程檔案",
              "description": null,
              "size": "Bytes",
              "publishUp": null,
              "downloadLink": "http://zerone.test/api/file/download/F2110Wv8",
              "contentType": "application/pdf"
            }
          ],
          "link": null
        },
        {
          "uuid": "6f0fbac6-ea7d-4c9d-b46d-5f8840c1d826",
          "title": "Making Digital Tangible: The Battle Against the Pixel Empire",
          "startTime": "09:45",
          "endTime": "10:55",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 1,
          "linkOpeningTime": null,
          "introtext": "數位資訊實體化：一場與像素帝國抗衡的戰役",
          "description": "時下人機互動的主流研究大多關注實用層面－使用者需求、實際的應用系統，與易用性評估。Tangible Bits 和 Radical Atoms 則是願景驅動的研究，並以藝術取向執行。現今社會一項技術可能一年後就過時了，一個應用系統可能十年後就遭取代。但我們相信，一個真正的願景，能持續發揮影響超過百年。\n\nTangible Bits 的研究目的是實現打造人、數位資訊，與實體環境之間無接縫的介面（Seamless Interfaces），為數位資訊與運算提供實體介面，讓人們可以直接操控位元（bits），也能感知其存在，無論是在前景或背景意識之下（foreground and background of our consciousness）。我們的目標是發明新的設計媒介，不但能適用於科學分析，也應用在藝術表達。Tangible Bits 的研究理念除了利用即時感知與數位回饋帶來的運算呈現外，也充分利用人類豐富的感官能力，與人們ㄧ生與實體世界互動的多樣技能。",
          "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "91312205-2007-4800-82fe-625f520c2ff0",
          "title": "休息交流時間",
          "startTime": "10:50",
          "endTime": "11:10",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [],
          "canRegistration": 0,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "",
          "locationName": "11樓休息區",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "6bffa1c5-a89f-4468-a386-c7b448d6b2c6",
          "title": "漸進式的改革與創新 - 後疫情時代的設計體驗轉型",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "產品會隨著人們的生活一起演進，歷史悠久的產品，會發展出深根蒂固的使用習慣，企業內部也有完整的流程與堅實企業文化。然而，習慣與框架有時會成為設計師推進創新的門檻。 Lydia將透過幾個Yahoo奇摩在台灣與Verizon Media在歐洲線的產品開發實例，分享這幾年如何以體驗式設計帶領團隊走進使用者的生活，並且將同理心應用在同事和決策者身上，進而打破既有設計規範、跨國文化，讓體驗文化在組織中發酵，漸進式的改革並創造與時俱進的產品在不同市場中。\n\n我們都期待改革是快速與有效的，但很多時候使用者多年的使用體驗已經定型，Lydia 帶領的 Verizon Media 設計團隊從前期策略規劃、使用者體驗訪談到設計開發與上線後監測優化都有一套完整流程，並帶動合作部門推進創新維度與執行。本次將分享在改革的腳步中，如何加快企業內部的接受度、開發與溝通的速度，並透過設計管理，讓這樣的成功案例可以跨國推進、建立 SOP ; 更重要的是，聚沙成塔，如何有規劃與節奏的讓使用者漸進式轉移，擁抱新的體驗設計，並因應不同市場的快速變化，Lydia也將分享幾個後疫情時代，產品快速調整的實際案例。",
          "locationName": "1101",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ebe86034-7fda-464b-bebe-081f35d9703a",
          "title": "設計作為一種推測與思想實驗",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            },
            {
              "name": "王小明2",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "「我們的現實世界被無垠的可能世界所包圍。」\n\nLubomír Doležel, Heterocosmica: Fiction and Possible Worlds, 1999\n2005年從英國皇家藝術學院（Royal College of Art）設計互動系（Design Interactions）開始慢慢萌芽的推測設計（Speculative Design）思維，經過十幾年之後，近年來在西方世界的設計、藝術文化領域，引起了廣大的影響與辯論，而很多專家也認為推測設計是「推測未來」的重要方法之一，而在東方世界，這股氛圍也緩緩升起中。\n\n「設計」如何作為一種推測、如何作為一種思想實驗？本次講座的講者宮保睿，試著帶領你從推測設計的發源起點、思維方式、現在狀況、可能未來、創作與教學實踐來解析各種面向，試著讓我們透過推測設計思維去思考著當面對未知未來時，「這個世界可能會變成什麼樣子？」這個重要的提問。",
          "locationName": "1102",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        },
        {
          "uuid": "ae14e984-b8a3-4c44-abd9-1ea32ee37583",
          "title": "春池循環設計的各種實踐與未來",
          "startTime": "11:10",
          "endTime": "11:50",
          "isEvent": 0,
          "slideshow": [
            {
              "path": "slideshow1.jpg",
              "default": 1
            },
            {
              "path": "slideshow2.jpg",
              "default": 0
            }
          ],
          "personnels": [
            {
              "name": "王小明",
              "companyName": "任職公司",
              "title": "專業講師",
              "phone": "聯絡電話",
              "email": "電子郵件",
              "description": "測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字測試文字",
              "categoryTitle": '人事身份',
              "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
              "state": 1,
            }
          ],
          "canRegistration": 1,
          "canApply": 0,
          "linkOpeningTime": null,
          "introtext": "",
          "description": "在氣候變遷與溫室效應影響著我們的生活，循環經濟與循環設計變成一個重要未來課題。 「我們過去的需求都是消耗，但我們想塑造的未來是，把未來的需求都成為新的創造。」春池玻璃未來將繼續以循環玻璃為載體，希望影響更多產業走向循環經濟。\n\n春池玻璃，目前跨足於工業原料、科技建材、文化藝術與觀光工廠。本業為專業回收玻璃與再處理之企業，總公司在台灣新竹，並擁有三家相關企業。目前每年回收並處理超過 10 萬噸的春池玻璃，目前為全台最具規模之廢棄玻璃回收業者。其企業理念為永續經營，綠色創新。在 2015 更獲得根留台灣，展望全球之「金根獎」之殊榮。蔡總統英文更在 2016 年 9 月親自參訪春池玻璃觀光工廠，並給予極高評價，稱春池玻璃為台灣「循環經濟」之典範。更在 2017 年獲得 British Chamber of Commerce 之 Better Business Award 社會企業首獎。更在 2018 年獲得總統創新獎與艾森豪獎金學人殊榮",
          "locationName": "1103",
          "city": "臺北市",
          "district": "中正區",
          "address": "中山南路11號11樓",
          "lat": 25.1234567,
          "lng": 121.02564,
          "files": [],
          "link": null
        }
      ]
    },
  ]
};

export const FAKE_EVENT_ITEM = FAKE_EVENT_ITEM_ONLINE_MULTIPLE_PARTIAL;

export const FAKE_SESSION_ITEM = {
  "date": "2021-10-03",
  "sessions": [
    {
      "uuid": "08724314-8b0d-4b8b-bc97-aaf5870b4725",
      "title": "年會開幕",
      "startTime": "09:30",
      "endTime": "09:45",
      "isEvent": 0,
      "slideshow": [
        {
          "path": "slideshow1.jpg",
          "default": 1
        },
        {
          "path": "slideshow2.jpg",
          "default": 0
        }
      ],
      "canRegistration": 0,
      "canApply": 0,
      "linkOpeningTime": null,
      "introtext": "開幕式",
      "description": "開幕式",
      "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
      "city": "臺北市",
      "district": "中正區",
      "address": "中山南路11號11樓",
      "lat": 25.1234567,
      "lng": 121.02564,
      "files": [],
      "link": null
    },
    {
      "uuid": "6f0fbac6-ea7d-4c9d-b46d-5f8840c1d826",
      "title": "Making Digital Tangible: The Battle Against the Pixel Empire",
      "startTime": "09:45",
      "endTime": "10:55",
      "isEvent": 0,
      "slideshow": [
        {
          "path": "slideshow1.jpg",
          "default": 1
        },
        {
          "path": "slideshow2.jpg",
          "default": 0
        }
      ],
      "canRegistration": 1,
      "canApply": 1,
      "linkOpeningTime": null,
      "introtext": "數位資訊實體化：一場與像素帝國抗衡的戰役",
      "description": "時下人機互動的主流研究大多關注實用層面－使用者需求、實際的應用系統，與易用性評估。Tangible Bits 和 Radical Atoms 則是願景驅動的研究，並以藝術取向執行。現今社會一項技術可能一年後就過時了，一個應用系統可能十年後就遭取代。但我們相信，一個真正的願景，能持續發揮影響超過百年。\n\nTangible Bits 的研究目的是實現打造人、數位資訊，與實體環境之間無接縫的介面（Seamless Interfaces），為數位資訊與運算提供實體介面，讓人們可以直接操控位元（bits），也能感知其存在，無論是在前景或背景意識之下（foreground and background of our consciousness）。我們的目標是發明新的設計媒介，不但能適用於科學分析，也應用在藝術表達。Tangible Bits 的研究理念除了利用即時感知與數位回饋帶來的運算呈現外，也充分利用人類豐富的感官能力，與人們ㄧ生與實體世界互動的多樣技能。",
      "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
      "city": "臺北市",
      "district": "中正區",
      "address": "中山南路11號11樓",
      "lat": 25.1234567,
      "lng": 121.02564,
      "files": [],
      "link": null
    },
    {
      "uuid": "91312205-2007-4800-82fe-625f520c2ff0",
      "title": "休息交流時間",
      "startTime": "10:50",
      "endTime": "11:10",
      "isEvent": 0,
      "slideshow": [
        {
          "path": "slideshow1.jpg",
          "default": 1
        },
        {
          "path": "slideshow2.jpg",
          "default": 0
        }
      ],
      "canRegistration": 0,
      "canApply": 0,
      "linkOpeningTime": null,
      "introtext": "",
      "description": "",
      "locationName": "11樓休息區",
      "city": "臺北市",
      "district": "中正區",
      "address": "中山南路11號11樓",
      "lat": 25.1234567,
      "lng": 121.02564,
      "files": [],
      "link": null
    },
    {
      "uuid": "6bffa1c5-a89f-4468-a386-c7b448d6b2c6",
      "title": "漸進式的改革與創新 - 後疫情時代的設計體驗轉型",
      "startTime": "11:10",
      "endTime": "11:50",
      "isEvent": 0,
      "slideshow": [
        {
          "path": "slideshow1.jpg",
          "default": 1
        },
        {
          "path": "slideshow2.jpg",
          "default": 0
        }
      ],
      "canRegistration": 1,
      "canApply": 0,
      "linkOpeningTime": null,
      "introtext": "",
      "description": "產品會隨著人們的生活一起演進，歷史悠久的產品，會發展出深根蒂固的使用習慣，企業內部也有完整的流程與堅實企業文化。然而，習慣與框架有時會成為設計師推進創新的門檻。 Lydia將透過幾個Yahoo奇摩在台灣與Verizon Media在歐洲線的產品開發實例，分享這幾年如何以體驗式設計帶領團隊走進使用者的生活，並且將同理心應用在同事和決策者身上，進而打破既有設計規範、跨國文化，讓體驗文化在組織中發酵，漸進式的改革並創造與時俱進的產品在不同市場中。\n\n我們都期待改革是快速與有效的，但很多時候使用者多年的使用體驗已經定型，Lydia 帶領的 Verizon Media 設計團隊從前期策略規劃、使用者體驗訪談到設計開發與上線後監測優化都有一套完整流程，並帶動合作部門推進創新維度與執行。本次將分享在改革的腳步中，如何加快企業內部的接受度、開發與溝通的速度，並透過設計管理，讓這樣的成功案例可以跨國推進、建立 SOP ; 更重要的是，聚沙成塔，如何有規劃與節奏的讓使用者漸進式轉移，擁抱新的體驗設計，並因應不同市場的快速變化，Lydia也將分享幾個後疫情時代，產品快速調整的實際案例。",
      "locationName": "1101",
      "city": "臺北市",
      "district": "中正區",
      "address": "中山南路11號11樓",
      "lat": 25.1234567,
      "lng": 121.02564,
      "files": [],
      "link": null
    },
    {
      "uuid": "ebe86034-7fda-464b-bebe-081f35d9703a",
      "title": "設計作為一種推測與思想實驗",
      "startTime": "11:10",
      "endTime": "11:50",
      "isEvent": 0,
      "slideshow": [
        {
          "path": "slideshow1.jpg",
          "default": 1
        },
        {
          "path": "slideshow2.jpg",
          "default": 0
        }
      ],
      "canRegistration": 1,
      "canApply": 0,
      "linkOpeningTime": null,
      "introtext": "",
      "description": "「我們的現實世界被無垠的可能世界所包圍。」\n\nLubomír Doležel, Heterocosmica: Fiction and Possible Worlds, 1999\n2005年從英國皇家藝術學院（Royal College of Art）設計互動系（Design Interactions）開始慢慢萌芽的推測設計（Speculative Design）思維，經過十幾年之後，近年來在西方世界的設計、藝術文化領域，引起了廣大的影響與辯論，而很多專家也認為推測設計是「推測未來」的重要方法之一，而在東方世界，這股氛圍也緩緩升起中。\n\n「設計」如何作為一種推測、如何作為一種思想實驗？本次講座的講者宮保睿，試著帶領你從推測設計的發源起點、思維方式、現在狀況、可能未來、創作與教學實踐來解析各種面向，試著讓我們透過推測設計思維去思考著當面對未知未來時，「這個世界可能會變成什麼樣子？」這個重要的提問。",
      "locationName": "1102",
      "city": "臺北市",
      "district": "中正區",
      "address": "中山南路11號11樓",
      "lat": 25.1234567,
      "lng": 121.02564,
      "files": [],
      "link": null
    },
    {
      "uuid": "ae14e984-b8a3-4c44-abd9-1ea32ee37583",
      "title": "春池循環設計的各種實踐與未來",
      "startTime": "11:10",
      "endTime": "11:50",
      "isEvent": 0,
      "slideshow": [
        {
          "path": "slideshow1.jpg",
          "default": 1
        },
        {
          "path": "slideshow2.jpg",
          "default": 0
        }
      ],
      "canRegistration": 1,
      "canApply": 0,
      "linkOpeningTime": null,
      "introtext": "",
      "description": "在氣候變遷與溫室效應影響著我們的生活，循環經濟與循環設計變成一個重要未來課題。 「我們過去的需求都是消耗，但我們想塑造的未來是，把未來的需求都成為新的創造。」春池玻璃未來將繼續以循環玻璃為載體，希望影響更多產業走向循環經濟。\n\n春池玻璃，目前跨足於工業原料、科技建材、文化藝術與觀光工廠。本業為專業回收玻璃與再處理之企業，總公司在台灣新竹，並擁有三家相關企業。目前每年回收並處理超過 10 萬噸的春池玻璃，目前為全台最具規模之廢棄玻璃回收業者。其企業理念為永續經營，綠色創新。在 2015 更獲得根留台灣，展望全球之「金根獎」之殊榮。蔡總統英文更在 2016 年 9 月親自參訪春池玻璃觀光工廠，並給予極高評價，稱春池玻璃為台灣「循環經濟」之典範。更在 2017 年獲得 British Chamber of Commerce 之 Better Business Award 社會企業首獎。更在 2018 年獲得總統創新獎與艾森豪獎金學人殊榮",
      "locationName": "1103",
      "city": "臺北市",
      "district": "中正區",
      "address": "中山南路11號11樓",
      "lat": 25.1234567,
      "lng": 121.02564,
      "files": [],
      "link": null
    }
  ]
};
